<template>
	<div>
		<PageHeader
			:data="{
				name: client.name,
				breadcrumbs: [
					{ name: 'Home', to: '/' },
					{ name: 'Clients', to: '/clients' },
				],
			}"
		/>

		<div v-if="!loading" class="row">
			<!-- Action Buttons -->
			<div class="col-md-9 p-1 mb-2">
				<div class="d-flex">
					<!-- ONBOARDING -->
					<button class="btn btn-connect card" @click="showOnboardingModal()">
						<template v-if="!client.onboarding_id">
							<span class="connect-title">Create Onboarding</span>
							<img src="../../assets/images/onboarding.svg" width="120px" alt="" />
							<font-awesome-icon class="text-danger connect-status" :icon="['fas', 'exclamation-triangle']" style="font-size: 14px; margin-bottom: 10px" />
						</template>
						<template v-else>
							<span class="connect-title">Onboarding</span>
							<img src="../../assets/images/onboarding.svg" width="90px" alt="" />
							<font-awesome-icon class="text-success connect-status" :icon="['fas', 'check-circle']" style="font-size: 16px" />
						</template>
					</button>

					<!-- JUNIPER CMS -->
					<button v-if="client.cms_version == 'Juniper'" class="btn btn-connect card" @click="showJuniperCreationModal()">
						<template v-if="!client.juniper_id">
							<span class="connect-title">Create Juniper</span>
							<img src="../../assets/images/juniper.svg" width="90px" alt="" />
							<font-awesome-icon class="text-danger connect-status" :icon="['fas', 'exclamation-triangle']" style="font-size: 14px; margin-bottom: 10px" />
						</template>
						<template v-else>
							<span class="connect-title">Juniper</span>
							<img src="../../assets/images/juniper.svg" width="90px" alt="" />
							<font-awesome-icon class="text-success connect-status" :icon="['fas', 'check-circle']" style="font-size: 16px" />
						</template>
					</button>

					<!-- DROPBOX -->
					<button v-if="client.cms_version == 'Juniper'" class="btn btn-connect card" @click="showDropboxModal()">
						<template v-if="!client.dropbox_id">
							<span class="connect-title">Create Dropbox</span>
							<img src="../../assets/images/dropbox.svg" width="90px" alt="" />
							<font-awesome-icon class="text-danger connect-status" :icon="['fas', 'exclamation-triangle']" style="font-size: 14px; margin-bottom: 10px" />
						</template>
						<template v-else>
							<span class="connect-title">Dropbox</span>
							<img src="../../assets/images/dropbox.svg" width="110px" alt="" />
							<font-awesome-icon class="text-success connect-status" :icon="['fas', 'check-circle']" style="font-size: 16px; margin-bottom: 10px" />
						</template>
					</button>

					<!-- SECURE FILE UPLOAD -->
					<button class="btn btn-connect card" @click="showSecureFileUploadModal()">
						<span class="connect-title">Secure File Upload</span>
						<img src="../../assets/images/secure-upload.svg" width="80px" alt="" style="margin: 10px 0;" />
						<font-awesome-icon class="text-success connect-status" :icon="['fas', 'check-circle']" style="font-size: 16px; margin-bottom: 10px" />
					</button>
				</div>
			</div>
			<!-- Client stats-->
			<div class="col-md-3 d-flex justify-content-end">
				<!-- INTERCOM SYNC -->
				<button class="btn btn-connect card me-2" style="width: 60px; height: 60px" @click="syncWithIntercom()" :disabled="syncingIntercom" title="Sync with Intercom">
					<span v-if="syncingIntercom" class="spinner-border spinner-border-sm" role="status" aria-label="Loading"></span>
					<font-awesome-icon v-else :icon="['fas', 'sync']" style="font-size: 20px" />
					<small style="font-size: 9px; margin-top: 4px">Intercom</small>
				</button>
				<!-- HEYGOV -->
				<button
					v-if="client.hg_client == 'yes' || client.cms_version == 'Juniper'"
					class="btn btn-connect card"
					style="width: 60px; height: 60px"
					@click="showHeyGovModal()"
				>
					<template v-if="!client.heygov_jurisdiction">
						<img src="../../assets/images/heygov.svg" width="40px" alt="" />
						<font-awesome-icon class="text-danger connect-status" :icon="['fas', 'exclamation-triangle']" style="font-size: 14px; margin-bottom: 10px" />
					</template>
					<template v-else>
						<img src="../../assets/images/heygov.svg" width="40px" alt="" />
						<font-awesome-icon class="text-success connect-status" :icon="['fas', 'check-circle']" style="font-size: 16px" />
					</template>
				</button>
			</div>
			<!-- Left sidebar -->
			<div class="col-4">
				<div class="card mb-2">
					<div
						class="card-header"
						:class="{
							'bg-success': client.dev_status == 'Live',
							'bg-secondary': client.dev_status !== 'Live',
						}"
					>
						<div v-if="!editFlag">
							<div v-if="client.dev_status == 'Live'" class="d-flex justify-content-between align-items-center">
								<h4 class="p-0 m-0 text-center text-white">{{ client.dev_status }}</h4>
								<span class="text-white" style="font-size: 12px; font-weight: 800">Website is live!</span>
							</div>
							<div
								v-if="client.dev_status == 'New - In Progress' || client.dev_status == 'Switch - In Progress' || client.dev_status == 'Upgrade - In Progress'"
								class="d-flex justify-content-between align-items-center"
							>
								<h4 class="p-0 m-0 text-center text-white">{{ client.dev_status }}</h4>
								<span class="text-white" style="font-size: 12px; font-weight: 800">Website is in development!</span>
							</div>
						</div>
						<div v-if="editFlag">
							<select class="form-select border-0" v-model="client.dev_status">
								<option value="">Select dev status</option>
								<option value="Live">Live</option>
								<option value="New - In Progress">New - In Progress</option>
								<option value="Switch - In Progress">Switch - In Progress</option>
								<option value="Upgrade - In Progress">Upgrade - In Progress</option>
							</select>
						</div>
					</div>
					<div class="card-body p-3">
						<div class="row mb-2 pb-1">
							<div class="col-2 d-flex justify-content-between align-items-center">
								<router-link v-if="client.municipality" :to="'/municipalities/edit/' + client.municipality.id">
									<span style="font-size: 36px">🏛️</span>
								</router-link>
								<span v-else style="font-size: 36px">🏛️</span>
							</div>
							<div class="col-10 d-flex align-items-start flex-column pt-1">
								<h4 class="mb-0" v-if="!editFlag">
									{{ client.name }}
									<a
										v-if="client.salesforce_account_id"
										target="_blank"
										:href="'https://hejdevdoo.lightning.force.com/lightning/r/Account/' + client.salesforce_account_id + '/view'"
										><img
											src="https://a.sfdcstatic.com/shared/images/c360-nav/salesforce-with-type-logo.svg"
											width="36"
											:title="'Salesforce ID' + client.salesforce_account_id"
										/>
									</a>
								</h4>
								<input type="text" class="form-control" v-else v-model="client.name" />
								<div class="d-flex justify-content-center">
									<span v-if="!editFlag">{{ client.county }}, </span>
									<input type="text" class="form-control w-50" v-else v-model="client.county" />
									<span v-if="!editFlag">{{ client.state }}</span>
									<input type="text" class="form-control w-50" v-else v-model="client.state" />
								</div>
							</div>
						</div>

						<!-- Select municipality if missing for type municipality -->
						<MunicipalitySearch
							:selected="null"
							class="mb-2"
							v-if="client.type === 'Municipality' && client.municipality_id === null"
							v-on:setMunicipality="setMunicipality"
						/>

						<!-- Client type -->
						<div class="d-flex justify-content-between align-items-center mb-2">
							<span class="fw-bold">Type</span>
							<span class="text-capitalize"> {{ client.type }}</span>
						</div>

						<!-- Municipality population if its municipality client -->
						<div class="d-flex justify-content-between align-items-center mb-2" v-if="client.municipality">
							<span class="fw-bold">Population</span>
							<span>👪 {{ client.municipality.population }}</span>
						</div>

						<!-- Municipality FIPS if its municipality client -->
						<div class="d-flex justify-content-between align-items-center mb-2" v-if="client.municipality">
							<span class="fw-bold">FIPS</span>
							<span>
								<a target="_blank" :href="'https://google.com/search?q=FIPS+' + client.municipality.fips">
									{{ client.municipality.fips }}
								</a>
							</span>
						</div>

						<!-- Municipality FIPS full if its municipality client -->
						<div class="d-flex justify-content-between align-items-center mb-2" v-if="client.municipality">
							<span class="fw-bold">FIPS full</span>
							<span>{{ client.municipality.fips_full }}</span>
						</div>

						<!-- Date from when is client with us -->
						<div class="d-flex justify-content-between align-items-center mb-2">
							<span class="fw-bold">Client since</span>
							<template v-if="!editFlag">
								<span>📆 {{ client.client_since | usDate }}</span>
							</template>
							<template v-if="editFlag">
								<input type="date" class="form-control form-control-sm border-0" v-model="client.client_since" />
							</template>
						</div>

						<!-- Status -->
						<div class="d-flex justify-content-between align-items-center mb-2">
							<span class="fw-bold">Client status</span>
							<!-- Status -->
							<div class="client-editable-item mb-2">
								<p class="m-0 p-0">
									<template v-if="client.status && !editFlag">
										<span v-if="client.status === 'active'" class="badge badge-success bg-success"> Active </span>
										<span v-if="client.status === 'suspended'" class="badge badge-warning bg-warning"> Suspended </span>
										<span v-if="client.status === 'deleted'" class="badge badge-danger bg-danger"> Deleted </span>
									</template>
									<template v-if="editFlag">
										<div class="d-flex justify-content-center align-items-end">
											<select class="form-select border-0" v-model="client.status">
												<option value="">Select status</option>
												<option value="active">Active</option>
												<option value="suspended">Suspended</option>
												<option value="deleted">Deleted</option>
											</select>
										</div>
									</template>
								</p>
							</div>

							<!-- Why they left, on the card, where anyone looking at a lost account
								expects to find it. One block per cancelled brand. -->
							<CancellationSummary
								:subscriptions="(client && client.subscriptions) || []"
								:reason-list="cancellationReasonList"
								:client-status="(client && client.status) || ''"
								:client-deleted-at="(client && client.deleted_at) || null"
								@edit="openReasonModal"
							/>
						</div>

						<div class="actions d-flex justify-content-between align-items-center">
							<div class="actions-left">
								<router-link
									title="Invoices"
									:to="'/clients/edit/' + client.id + '/billing'"
									class="btn btn-primary btn-sm me-2"
									v-if="authUser.email.includes('srdjan')"
								>
									<font-awesome-icon :icon="['fas', 'receipt']" />
								</router-link>
							</div>
							<div class="actions-right">
								<button
									data-bs-toggle="offcanvas"
									data-bs-target="#offcanvasActivities"
									aria-controls="offcanvasActivities"
									class="btn btn-secondary btn-sm me-2"
									title="Contact history of changes"
									type="button"
								>
									<font-awesome-icon :icon="['fas', 'history']" />
								</button>
								<button class="btn btn-danger btn-sm me-2" title="Remove Client" type="button" @click="removeClient()">
									<font-awesome-icon :icon="['fas', 'trash']" />
								</button>
							</div>
						</div>
					</div>
				</div>

				<!-- Dashboard modules -->
				<div class="card mb-2">
					<div class="card-body p-3">
						<div class="row mb-2 pb-2">
							<div class="col-12 d-flex justify-content-between align-items-center">
								<h5 class="mb-0">Dashboard modules 🗃️</h5>
							</div>
						</div>
						<router-link :to="'/clients/edit/' + client.id + '/subscribers'" class="btn btn-primary btn-sm me-1">
							<font-awesome-icon :icon="['fas', 'newspaper']" /> Subscribers
						</router-link>
						<button class="btn btn-info btn-sm me-1" @click="dashboardWeatherFlag = !dashboardWeatherFlag">
							<font-awesome-icon :icon="['fas', 'umbrella']" /> Weather
						</button>
						<div class="mt-2" v-if="dashboardWeatherFlag">
							<h6>TW Weather</h6>
							<div>
								<div class="form-group mb-2">
									<label for="">Latitude</label>
									<input type="text" class="form-control form-control-sm" v-model="client.latitude" />
								</div>
								<div class="form-group mb-2">
									<label for="">Longitude</label>
									<input type="text" class="form-control form-control-sm" v-model="client.longitude" />
								</div>
								<div class="form-group">
									<label>TW Weather</label>
									<div class="form-check form-switch my-2">
										<input class="form-check-input" v-model="twWeatherActive" type="checkbox" role="button" />
									</div>
								</div>

								<button
									type="button"
									class="btn btn-success float-start btn-sm justify-content-center align-items-center d-flex"
									@click="updateWeather()"
									:disabled="loadingWeather"
								>
									<span v-if="!loadingWeather"><font-awesome-icon :icon="['fas', 'umbrella']" /> Update Weather</span>
									<span v-if="loadingWeather" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
									<span v-if="loadingWeather">Loading...</span>
								</button>

								<button type="button" v-if="authUser.permissions.includes('CLIENT_UPDATE')" class="btn btn-primary float-end btn-sm" @click="updateClient()">
									Update
								</button>
							</div>
						</div>
					</div>
				</div>

				<!-- Contact information -->
				<div class="card mb-2" v-if="client && client.id">
					<div class="card-body p-3">
						<PricingQuotesCard :client-id="client.id" title="Quotes 💬" />
					</div>
				</div>

				<div class="card mb-2">
					<div class="card-body p-3">
						<div class="row mb-2 pb-2">
							<div class="col-12 d-flex justify-content-between align-items-center">
								<h5 class="mb-0">Contact info 📍</h5>
								<button class="btn btn-secondary btn-sm" @click="editFlag = !editFlag">
									<template v-if="editFlag">Disable </template>
									<template v-if="!editFlag">Enable </template>
									Edit
								</button>
							</div>
						</div>

						<!-- Email -->
						<div class="client-editable-item mb-2">
							<p class="m-0 p-0 mt-2 fw-bold">Email 📧</p>
							<p class="m-0 p-0">
								<template v-if="!editFlag"> {{ client.email }} </template>
								<template v-if="editFlag">
									<div class="d-flex justify-content-center align-items-end">
										<input type="text" class="form-control form-control-sm border-0" placeholder="enter email" v-model="client.email" />
									</div>
								</template>
							</p>
						</div>

						<!-- Phone -->
						<div class="client-editable-item mb-2">
							<p class="m-0 p-0 mt-2 fw-bold">Phone ☎️</p>
							<p class="m-0 p-0">
								<template v-if="!editFlag"> {{ client.phone }} </template>
								<template v-if="editFlag">
									<div class="d-flex justify-content-center align-items-end">
										<input type="text" class="form-control form-control-sm border-0" placeholder="(999) 999-9999" v-model="client.phone" />
									</div>
								</template>
							</p>
						</div>

						<!-- Physical address -->
						<div class="client-editable-item mb-2">
							<p class="m-0 p-0 mt-2 fw-bold">
								Physical address 📍 <br />
								<small class="fw-normal">(Enter address in format: address street, city, state <code>(abbr!)</code>, zip)</small>
							</p>
							<p class="m-0 p-0">
								<template v-if="!editFlag"> {{ client.address }} </template>
								<template v-if="editFlag">
									<div class="d-flex justify-content-center align-items-end">
										<input type="text" class="form-control form-control-sm border-0" placeholder="enter physical address" v-model="client.address" />
									</div>
								</template>
							</p>
						</div>

						<!-- Mailing address -->
						<div class="client-editable-item mb-2">
							<p class="m-0 p-0 mt-2 fw-bold">
								Mailing address 📍 <br />
								<small class="fw-normal">(Enter address in format: address street, city, state <code>(abbr!)</code> , zip)</small>
							</p>
							<p class="m-0 p-0">
								<template v-if="client.address_mailing && !editFlag">{{ client.address_mailing }} </template>
								<template v-if="editFlag">
									<div class="d-flex justify-content-center align-items-end">
										<input type="text" class="form-control form-control-sm border-0" placeholder="enter mailing address" v-model="client.address_mailing" />
									</div>
								</template>
							</p>
						</div>

						<button type="button" v-if="editFlag && authUser.permissions.includes('CLIENT_UPDATE')" class="btn btn-primary float-end btn-sm" @click="updateClient()">
							Update
						</button>
					</div>
				</div>

				<!-- Members info -->
				<div class="card mb-2">
					<div class="card-body p-3">
						<div class="row mb-2 pb-2">
							<div class="col-12 d-flex justify-content-between align-items-center">
								<h5 class="mb-0">Members 🧑</h5>
								<button type="button" data-bs-toggle="modal" data-bs-target="#create" class="btn btn-primary btn-sm">
									<font-awesome-icon :icon="['fas', 'plus']" />
								</button>
							</div>
						</div>
						<template v-for="contact in client.contacts">
							<div :key="contact.id" class="contact-item d-flex align-items-center justify-content-between border-bottom py-2">
								<a href="#" class="text-black fs-6 text-decoration-none">
									<span
										data-bs-toggle="tooltip"
										data-bs-html="true"
										:title="'<b>Email:</b> ' + contact.email + '<br><b>Address:</b> ' + contact.address + '<br><b>Title:</b> ' + contact.title"
										>{{ contact.first_name }} {{ contact.last_name }}</span
									>
									<span class="badge badge-primary bg-primary ms-2" title="Primary contact of municipality" v-if="contact.main"> primary </span>
									<span data-bs-toggle="tooltip" data-bs-html="true" class="badge badge-danger bg-danger ms-2" title="Billing Contact 💰" v-if="contact.billing">
										<font-awesome-icon :icon="['fas', 'file-invoice-dollar']" />
									</span>
								</a>
								<div class="buttons">
									<router-link class="btn btn-primary btn-sm me-1" :to="'/client-contacts/edit/' + contact.id">
										<font-awesome-icon :icon="['fas', 'edit']" />
									</router-link>
									<button type="button" @click="deleteContact(contact)" class="btn btn-danger btn-sm">
										<font-awesome-icon :icon="['fas', 'trash']" />
									</button>
								</div>
							</div>
						</template>
					</div>
				</div>

				<!-- Dashboard info -->
				<div class="card mb-2" v-if="client.tw_client === 'yes'">
					<div class="card-body p-3">
						<div class="row mb-2 pb-2">
							<div class="col-12">
								<h5 class="mb-0">Dashboard</h5>
								<p class="p-0 m-0">Town Web dashboard related settings</p>
							</div>
							<!-- Google Analytics Code -->
							<div class="client-editable-item mb-2">
								<p class="m-0 p-0 mt-2 fw-bold">Google Analytics Code</p>
								<p class="m-0 p-0">
									<template>
										<div class="form-group">
											<input type="text" class="form-control form-control-sm border-0" placeholder="enter google analytics code" v-model="client.ga_code" />
											<div id="emailHelp" class="form-text">Google Analytics Code (Add propery ID with prefix 'GA4-')</div>
										</div>
									</template>
								</p>
							</div>

							<!-- Welcome message -->
							<div class="client-editable-item mb-2">
								<p class="m-0 p-0 mt-2 fw-bold">Welcome message</p>
								<p class="m-0 p-0">
									<template>
										<div class="d-flex justify-content-center align-items-end">
											<input
												type="text"
												class="form-control form-control-sm border-0"
												placeholder="enter welcome message for dashboard"
												v-model="client.dashboard_message"
											/>
										</div>
									</template>
								</p>
							</div>
						</div>
						<button v-if="authUser.permissions.includes('CLIENT_UPDATE')" type="button" class="btn btn-primary float-end btn-sm" @click="updateClient()">Update</button>
					</div>
				</div>

				<!-- Server info -->
				<div class="card mb-2" v-if="client.tw_client === 'yes'">
					<div class="card-body p-3">
						<div class="row mb-2 pb-2">
							<div class="col-12">
								<h5 class="mb-0">Server</h5>
								<p class="p-0 m-0">Info about server where website is located</p>
							</div>

							<!-- Server name -->
							<div class="client-editable-item mb-2">
								<p class="m-0 p-0 mt-2 fw-bold">Server Name</p>
								<p class="m-0 p-0">
									<template>
										<div class="d-flex justify-content-center align-items-end">
											<select class="form-select border-0" v-on:change="setServer" v-model="client.server">
												<option value="">Server not set</option>
												<option value="Rackspace RS1">Rackspace RS1 (161.47.89.78)</option>
												<option value="Hetzner DS3">Hetzner DS3 (138.201.199.88)</option>
												<option value="Hetzner DS2">Hetzner DS2 (46.4.50.219)</option>
												<option value="Hetzner DS4">Hetzner DS4 (176.9.158.45)</option>
												<option value="DigitalOcean DO1">DigitalOcean DO1 (162.243.184.78)</option>
												<option value="AWS WEDC">AWS WEDC (34.216.252.96)</option>
												<option value="DigitalOcean DO18">DigitalOcean DO18 (104.131.73.154)</option>
												<option value="AWS LS1">AWS LS1 (18.219.87.118)</option>
											</select>
										</div>
									</template>
								</p>
							</div>

							<!-- Server IP -->
							<div class="client-editable-item mb-2">
								<p class="m-0 p-0 mt-2 fw-bold">Server IP</p>
								<p class="m-0 p-0">
									<template>
										<div class="d-flex justify-content-center align-items-end">
											<input
												type="text"
												readonly
												class="form-control form-control-sm border-0"
												placeholder="enter server IP address"
												v-model="client.server_ip"
											/>
										</div>
									</template>
								</p>
							</div>
						</div>
						<button v-if="authUser.permissions.includes('CLIENT_UPDATE')" type="button" class="btn btn-primary float-end btn-sm" @click="updateClient()">Update</button>
					</div>
				</div>

				<!-- Notes -->
				<div class="card mb-2" v-if="false">
					<div class="card-body p-3">
						<div class="row pb-2">
							<div class="col-12 d-flex justify-content-between align-items-center">
								<h5 class="mb-2">Notes</h5>
								<span>ℹ️ notes about client</span>
							</div>
						</div>

						<div v-if="clientNotes.length > 0" class="mb-3">
							<template v-for="note in clientNotes">
								<div
									:key="note.id"
									class="note-item mb-2 border-bottom py-2 d-flex justify-content-between align-items-center"
									:class="note.type === 'important' ? 'bg-danger-light' : ''"
								>
									<span class="note-item-date">{{ note.created_at | usDateTime }}</span>
									<span class="py-2 ms-2">{{ note.note }}</span>
									<button @click="deleteNote(note)" type="button" class="note-item-delete btn btn-sm btn-danger me-2">
										<font-awesome-icon :icon="['fas', 'trash']" />
									</button>
								</div>
							</template>
						</div>

						<div class="add-note row">
							<div class="col-12">
								<div class="form-check form-check-inline">
									<input class="form-check-input" type="radio" v-model="newNote.type" id="defaultNote" value="default" />
									<label class="form-check-label" for="defaultNote">Default</label>
								</div>
								<div class="form-check form-check-inline">
									<input class="form-check-input" type="radio" v-model="newNote.type" id="devNote" value="important" />
									<label class="form-check-label" for="devNote">Important</label>
								</div>

								<textarea
									v-model="newNote.note"
									class="form-control border-0"
									:class="newNote.type === 'important' ? 'bg-danger-light' : ''"
									cols="5"
									rows="3"
									placeholder="enter your note"
								></textarea>
								<button class="btn btn-default btn-sm float-start mt-2" @click="newNote.note = ''" v-if="newNote.note.length > 3">
									<font-awesome-icon :icon="['fas', 'history']" /> clear
								</button>
								<button @click="storeNote()" class="btn btn-primary btn-sm float-end mt-2" v-if="newNote.note.length > 3">
									<font-awesome-icon :icon="['fas', 'check-circle']" /> Save note
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col-8">
				<ul class="nav nav-pills mb-3 bg-white rounded shadow-sm" id="pills-tab" role="tablist">
					<li class="nav-item" role="presentation">
						<button
							class="nav-link active"
							id="pills-products-tab"
							data-bs-toggle="pill"
							data-bs-target="#pills-products"
							type="button"
							role="tab"
							aria-controls="pills-products"
							aria-selected="true"
						>
							📦 Products
						</button>
					</li>
					<li class="nav-item" role="presentation">
						<button
							class="nav-link"
							id="pills-feedback-tab"
							data-bs-toggle="pill"
							data-bs-target="#pills-feedback"
							type="button"
							role="tab"
							aria-controls="pills-feedback"
							aria-selected="false"
						>
							⭐ Feedback
						</button>
					</li>
					<li class="nav-item" role="presentation">
						<button
							class="nav-link"
							id="pills-support-tab"
							data-bs-toggle="pill"
							data-bs-target="#pills-support"
							type="button"
							role="tab"
							aria-controls="pills-support"
							aria-selected="false"
						>
							💬 Support
						</button>
					</li>
					<li class="nav-item" role="presentation">
						<button
							class="nav-link"
							id="pills-billing-tab"
							data-bs-toggle="pill"
							data-bs-target="#pills-billing"
							type="button"
							role="tab"
							aria-controls="pills-billing"
							aria-selected="false"
						>
							💰 Billing
						</button>
					</li>
					<li class="nav-item" role="presentation">
						<button
							class="nav-link"
							id="pills-notes-tab"
							data-bs-toggle="pill"
							data-bs-target="#pills-notes"
							type="button"
							role="tab"
							aria-controls="pills-notes"
							aria-selected="false"
						>
							📝 Notes
						</button>
					</li>
					<li
						v-if="authUser.email.includes('srdjan') || authUser.email.includes('marta') || authUser.email.includes('marko') || authUser.email.includes('ivan')"
						class="nav-item"
						role="presentation"
					>
						<button
							class="nav-link"
							id="pills-dns-tab"
							data-bs-toggle="pill"
							data-bs-target="#pills-dns"
							type="button"
							role="tab"
							aria-controls="pills-dns"
							aria-selected="false"
						>
							🌎 DNS
						</button>
					</li>
					<li class="nav-item" role="presentation">
						<button
							class="nav-link"
							id="pills-emails-tab"
							data-bs-toggle="pill"
							data-bs-target="#pills-emails"
							type="button"
							role="tab"
							aria-controls="pills-emails"
							aria-selected="false"
						>
							📧 Emails Info
						</button>
					</li>
				</ul>

				<div class="tab-content mt-2" id="pills-tabContent">
					<!-- Products Tab -->
					<div class="tab-pane fade show active" id="pills-products" role="tabpanel" aria-labelledby="pills-products-tab">
						<!-- BASIC INFO -->
						<div class="card mt-2">
							<div class="card-header border-bottom">
								<h5 class="card-title">Info</h5>
								<p class="card-subtitle">Basic information about client</p>
							</div>
							<div class="card-body">
								<div class="row">
									<div class="col-12 col-md-6 mb-3">
										<div class="client-editable-item">
											<div class="form-group form-group-sk">
												<label class="form-label form-label-sk">Name</label>
												<input v-if="editFlag" type="text" class="form-control" v-model="client.name" />
												<div v-else>{{ client.name }}</div>
											</div>
										</div>
									</div>
									<!-- Website -->
									<div class="col-12 col-md-6 mb-3">
										<div class="client-editable-item">
											<div class="form-group form-group-sk">
												<label class="form-label form-label-sk">Website</label>
												<input v-if="editFlag" type="text" class="form-control" v-model="client.website" />
												<div v-else>
													{{ client.website }} <a :href="client.website" target="_blank"><font-awesome-icon :icon="['fas', 'link']"/></a>
												</div>
											</div>
										</div>
									</div>
									<div class="col-12 col-md-3 mb-3">
										<div class="client-editable-item">
											<div class="form-group form-group-sk">
												<label class="form-label form-label-sk">City</label>
												<input v-if="editFlag" type="text" class="form-control" v-model="client.city" />
												<div v-else>{{ client.city }}</div>
											</div>
										</div>
									</div>
									<div class="col-12 col-md-3 mb-3">
										<div class="client-editable-item">
											<div class="form-group form-group-sk">
												<label class="form-label form-label-sk">County</label>
												<input v-if="editFlag" type="text" class="form-control" v-model="client.county" />
												<div v-else>{{ client.county }}</div>
											</div>
										</div>
									</div>
									<div class="col-12 col-md-3 mb-3">
										<div class="client-editable-item">
											<div class="form-group form-group-sk">
												<label class="form-label form-label-sk">State</label>
												<input v-if="editFlag" type="text" class="form-control" v-model="client.state" />
												<div v-else>{{ client.state }}</div>
											</div>
										</div>
									</div>
									<div class="col-12 col-md-3 mb-3">
										<div class="client-editable-item">
											<div class="form-group form-group-sk">
												<label class="form-label form-label-sk">State Abb</label>
												<input v-if="editFlag" type="text" class="form-control" v-model="client.state_abb" />
												<div v-else>{{ client.state_abb }}</div>
											</div>
										</div>
									</div>
									<div class="col-12 col-md-3 mb-3">
										<div class="client-editable-item">
											<div class="form-group form-group-sk">
												<label class="form-label form-label-sk">Latitude</label>
												<input v-if="editFlag" type="text" class="form-control" v-model="client.latitude" />
												<div v-else>{{ client.latitude }}</div>
											</div>
										</div>
									</div>
									<div class="col-12 col-md-3 mb-3">
										<div class="client-editable-item">
											<div class="form-group form-group-sk">
												<label class="form-label form-label-sk">Longitude</label>
												<input v-if="editFlag" type="text" class="form-control" v-model="client.longitude" />
												<div v-else>{{ client.longitude }}</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<!-- Town Web -->
						<div class="card mt-2">
							<div class="card-body">
								<div class="header d-flex justify-content-between align-items-center">
									<img
										width="163px"
										src="https://assets.website-files.com/5fd9ec20a182fdcd717d73c6/609c149075fd9aeb72cf78b7_Town_Web_Trademark-p-2000.png"
										alt=""
									/>
									<div class="form-check form-switch">
										<input class="form-check-input" v-model="townweb" type="checkbox" role="button" />
									</div>
								</div>
								<div class="body" v-if="townweb">
									<!-- Contract details -->
									<div class="tw-contract-details row">
										<!-- Contract type -->
										<div class="col-md-12 mt-2">Contract details</div>
										<div class="col-3">
											<div class="client-editable-item mb-2">
												<p class="m-0 p-0 mt-2 fw-bold">Contract type</p>
												<p class="m-0 p-0">
													<template v-if="client.contract_type && !editFlag">{{ client.contract_type }} </template>
													<template v-if="editFlag">
														<div class="d-flex justify-content-center align-items-end">
															<select class="form-select border-0" v-model="client.contract_type">
																<option value="">Select contract type</option>
																<option value="1 year">1 year</option>
																<option value="2 years">2 years</option>
																<option value="3 years">3 years</option>
																<option value="4 years">4 years</option>
																<option value="5 years">5 years</option>
																<option value="No contract">No contract</option>
															</select>
														</div>
													</template>
												</p>
											</div>
										</div>
										<!-- Contract start date -->
										<div class="col-3">
											<div class="client-editable-item mb-2">
												<p class="m-0 p-0 mt-2 fw-bold">Contract start</p>
												<p class="m-0 p-0">
													<template v-if="client.contract_start_at && !editFlag">{{ client.contract_start_at | usDate }} </template>
													<template v-if="editFlag">
														<div class="d-flex justify-content-center align-items-end">
															<input type="date" class="form-control border-0" v-model="client.contract_start_at" />
														</div>
													</template>
												</p>
											</div>
										</div>
										<!-- Contract ends date -->
										<div class="col-3">
											<div class="client-editable-item mb-2">
												<p class="m-0 p-0 mt-2 fw-bold">Contract end</p>
												<p class="m-0 p-0">
													<template v-if="client.contract_ends_at && !editFlag">{{ client.contract_ends_at | usDate }} </template>
													<template v-if="editFlag">
														<div class="d-flex justify-content-center align-items-end">
															<input type="date" class="form-control border-0" v-model="client.contract_ends_at" />
														</div>
													</template>
												</p>
											</div>
										</div>
										<!-- Contract expires in -->
										<div class="col-3 d-flex justify-content-center align-items-center">
											<div class="client-editable-item mb-2 d-flex justify-content-center align-items-center">
												<p class="m-0 p-0">
													<template v-if="client.contract_ends_at !== null && client.contract_ends_at !== '0000-00-00 00:00:00'">
														<span class="badge badge-success bg-success" v-if="dateDifferenceDays(client.contract_ends_at) >= 30">
															{{ dateDifferenceDays(client.contract_ends_at) }}
															days
														</span>
														<span
															class="badge badge-warning bg-warning"
															v-if="dateDifferenceDays(client.contract_ends_at) < 30 && dateDifferenceDays(client.contract_ends_at) > 0"
														>
															{{ dateDifferenceDays(client.contract_ends_at) }}
															days
														</span>
														<span v-if="dateDifferenceDays(client.contract_ends_at) < 0" class="badge badge-danger bg-danger"> Out of contract </span>
													</template>
													<template v-else>
														<span class="badge badge-danger bg-danger"> End date missing </span>
													</template>
												</p>
											</div>
										</div>
									</div>

									<!-- Product details -->
									<div class="row">
										<div class="col-12">
											<p class="p-0 m-0">Product details</p>
										</div>
										<!-- Website -->
										<div class="col-6">
											<div class="client-editable-item mb-2">
												<p class="m-0 p-0 mt-2 fw-bold">Website 🌎</p>
												<p class="m-0 p-0">
													<template v-if="client.website && !editFlag">
														<a :href="client.website" target="_blank">{{ client.website }}</a>
													</template>
													<template v-if="editFlag">
														<div class="d-flex justify-content-center align-items-end">
															<input type="text" class="form-control border-0" v-model="client.website" />
														</div>
													</template>
												</p>
											</div>
										</div>
										<!-- CMS version -->
										<div class="col-6">
											<div class="client-editable-item mb-2">
												<p class="m-0 p-0 mt-2 fw-bold">CMS Version</p>
												<p class="m-0 p-0">
													<template v-if="client.cms_version && !editFlag">
														{{ client.cms_version }}
													</template>
													<template v-if="editFlag">
														<div class="d-flex justify-content-center align-items-end">
															<select class="form-select border-0" v-model="client.cms_version">
																<option value="">Select CMS version</option>
																<option value="Juniper">Juniper</option>
																<option value="v1">v1</option>
																<option value="v2">v2</option>
																<option value="v3">v3</option>
																<option value="v4">v4</option>
																<option value="v5 Wordpress">v5 Wordpress</option>
																<option value="Custom Design">Custom Design</option>
																<option value="Greenwood">Greenwood</option>
																<option value="Other">Other</option>
															</select>
														</div>
													</template>
												</p>
											</div>
										</div>

										<!-- Theme -->
										<div class="col-4">
											<div class="client-editable-item mb-2">
												<p class="m-0 p-0 mt-2 fw-bold">Theme</p>
												<p class="m-0 p-0">
													<template v-if="client.theme && !editFlag">
														{{ client.theme }}
													</template>
													<template v-if="editFlag">
														<div class="d-flex justify-content-center align-items-end">
															<select class="form-select border-0" v-model="client.theme">
																<option value="">Select theme</option>
																<option value="Premier">Premier</option>
																<option value="Juniper Maverick">Juniper Maverick</option>
																<option value="Juniper Lightyear">Juniper Lightyear</option>
																<option value="Juniper Mockingbird">Juniper Mockingbird</option>
																<option value="2022 Theme">2022 Theme</option>
																<option value="2022 Mini Theme">2022 Mini Theme</option>
																<option value="TW 2020">TW 2020</option>
																<option value="TW 2019">TW 2019</option>
																<option value="TW 2018">TW 2018</option>
																<option value="Rural Refined">Rural Refined</option>
																<option value="Urban Modern">Urban Modern</option>
																<option value="Reclaimed Modern">Reclaimed Modern</option>
																<option value="NY Super Theme">NY Super Theme</option>
																<option value="Rural Rustic">Rural Rustic</option>
																<option value="The Thrill is Gone - OGv5">The Thrill is Gone - OGv5</option>
																<option value="Custom Design">Custom Design</option>
																<option value="Other">Other</option>
															</select>
														</div>
													</template>
												</p>
											</div>
										</div>
										<!-- Package -->
										<div class="col-4">
											<div class="client-editable-item mb-2">
												<p class="m-0 p-0 mt-2 fw-bold">Package</p>
												<p class="m-0 p-0">
													<template v-if="client.package && !editFlag">
														{{ client.package }}
													</template>
													<template v-if="editFlag">
														<div class="d-flex justify-content-center align-items-end">
															<select class="form-select border-0" v-model="client.package">
																<option value="">Select package</option>
																<option value="Select">Select</option>
																<option value="Select Plus">Select Plus</option>
																<option value="Elite">Elite</option>
																<option value="Essential">Essential</option>
																<option value="Deluxe">Deluxe</option>
																<option value="Super Deluxe">Super Deluxe</option>
																<option value="Rural">Rural</option>
																<option value="Community Foundation">Community Foundation</option>
																<option value="Community Foundation with Payments">Community Foundation with Payments</option>
																<option value="Other">Other</option>
															</select>
														</div>
													</template>
												</p>
											</div>
										</div>
										<!-- Free redesign -->
										<div class="col-4">
											<div class="client-editable-item mb-2">
												<p class="m-0 p-0 mt-2 fw-bold">Free redesign</p>
												<p class="m-0 p-0">
													<template v-if="!editFlag">
														<span v-if="client.free_redesign == 'yes'" class="badge badge-success bg-success">Yes</span>
														<span v-else class="badge badge-danger bg-danger">No</span>
													</template>
													<template v-if="editFlag">
														<div class="d-flex justify-content-center align-items-end">
															<select class="form-select border-0" v-model="client.free_redesign">
																<option value="yes">Yes</option>
																<option value="no">No</option>
															</select>
														</div>
													</template>
												</p>
											</div>
										</div>

										<!-- Facebook syndication -->
										<div class="col-6">
											<div class="client-editable-item mb-2">
												<p class="m-0 p-0 mt-2 fw-bold">Facebook syndication</p>
												<p class="m-0 p-0">
													<template v-if="client.facebook_syndication && !editFlag">
														<span v-if="client.facebook_syndication === 'no'" class="badge badge-danger bg-danger"> No </span>
														<span v-if="client.facebook_syndication === 'yes,not implemented'" class="badge badge-primary bg-primary">
															Yes, not implemented
														</span>
														<span v-if="client.facebook_syndication === 'yes,implemented'" class="badge badge-success bg-success">
															Yes, implemented
														</span>
													</template>
													<template v-if="editFlag">
														<div class="d-flex justify-content-center align-items-end">
															<select class="form-select border-0" v-model="client.facebook_syndication">
																<option value="">Select status</option>
																<option value="no">No</option>
																<option value="yes,not implemented">Yes, not implemented</option>
																<option value="yes,implemented">Yes, implemented</option>
															</select>
														</div>
													</template>
												</p>
											</div>
										</div>

										<!-- Branded emails -->
										<div class="col-6">
											<div class="client-editable-item mb-2">
												<p class="m-0 p-0 mt-2 fw-bold">Branded emails</p>
												<p class="m-0 p-0">
													<template v-if="client.branded_emails && !editFlag">
														<span v-if="client.branded_emails === 'no'" class="badge badge-danger bg-danger"> No </span>
														<span v-if="client.branded_emails === 'yes,not implemented'" class="badge badge-primary bg-primary">
															Yes, not implemented
														</span>
														<span v-if="client.branded_emails === 'yes,not implemented,archiving'" class="badge badge-primary bg-primary">
															Yes, not implemented
														</span>
														<span v-if="client.branded_emails === 'yes,implemented'" class="badge badge-success bg-success"> Yes, implemented </span>
														<span v-if="client.branded_emails === 'yes,implemented,archiving'" class="badge badge-success bg-success">
															Yes, implemented, archiving
														</span>
													</template>
													<template v-if="editFlag">
														<div class="d-flex justify-content-center align-items-end">
															<select class="form-select border-0" v-model="client.branded_emails">
																<option value="">Select status</option>
																<option value="no">No</option>
																<option value="yes,not implemented">Yes, not implemented</option>
																<option value="yes,not implemented">Yes,not implemented,archiving</option>
																<option value="yes,implemented">Yes, implemented</option>
																<option value="yes,implemented,archiving">Yes,implemented,archiving</option>
															</select>
														</div>
													</template>
												</p>
											</div>
										</div>

										<!-- Online payments -->
										<div class="col-6">
											<div class="client-editable-item mb-2">
												<p class="m-0 p-0 mt-2 fw-bold">Online payments</p>
												<p class="m-0 p-0">
													<template v-if="client.online_payments && !editFlag">
														<span v-if="client.online_payments === 'no'" class="badge badge-danger bg-danger"> No </span>
														<span v-if="client.online_payments === 'yes,not implemented'" class="badge badge-primary bg-primary">
															Yes, not implemented
														</span>
														<span v-if="client.online_payments === 'yes,implemented'" class="badge badge-success bg-success"> Yes, implemented </span>
													</template>
													<template v-if="editFlag">
														<div class="d-flex justify-content-center align-items-end">
															<select class="form-select border-0" v-model="client.online_payments">
																<option value="">Select status</option>
																<option value="no">No</option>
																<option value="yes,not implemented">Yes, not implemented</option>
																<option value="yes,implemented">Yes, implemented</option>
															</select>
														</div>
													</template>
												</p>
											</div>
										</div>

										<!-- Live stream -->
										<div class="col-6">
											<div class="client-editable-item mb-2">
												<p class="m-0 p-0 mt-2 fw-bold">Live stream</p>
												<p class="m-0 p-0">
													<template v-if="client.live_stream && !editFlag">
														<span v-if="client.live_stream === 'no'" class="badge badge-danger bg-danger"> No </span>
														<span v-if="client.live_stream === 'yes,not implemented'" class="badge badge-primary bg-primary">
															Yes, not implemented
														</span>
														<span v-if="client.live_stream === 'yes,implemented'" class="badge badge-success bg-success"> Yes, implemented </span>
													</template>
													<template v-if="editFlag">
														<div class="d-flex justify-content-center align-items-end">
															<select class="form-select border-0" v-model="client.live_stream">
																<option value="">Select status</option>
																<option value="no">No</option>
																<option value="yes,not implemented">Yes, not implemented</option>
																<option value="yes,implemented">Yes, implemented</option>
															</select>
														</div>
													</template>
												</p>
											</div>
										</div>

										<!-- Package -->
										<div class="col-4">
											<div class="client-editable-item mb-2">
												<p class="m-0 p-0 mt-2 fw-bold">WGS</p>
												<p class="m-0 p-0">
													<template v-if="client.white_glove_service && !editFlag">
														<span v-if="client.white_glove_service === 'no' && client.white_glove_service" class="badge badge-danger bg-danger">
															No
														</span>
														<span
															v-if="client.white_glove_service === 'Yes, email only' && client.white_glove_service"
															class="badge badge-primary bg-primary"
														>
															Yes, email only
														</span>
														<span
															v-if="client.white_glove_service === 'Yes, email+phone' && client.white_glove_service"
															class="badge badge-success bg-success"
														>
															Yes, email+phone
														</span>
														<span
															v-if="client.white_glove_service === 'Free trial' && client.white_glove_service"
															class="badge badge-success bg-success"
														>
															Free trial
														</span>

														<template v-if="client.white_glove_service === 'Free trial' && client.white_glove_service">
															<span class="ms-2">Expires on {{ client.white_glove_service_expiration | usDate }}</span>
														</template>
													</template>
													<template
														v-if="
															client.white_glove_service !== 'no' &&
																client.white_glove_service !== 'Yes, email only' &&
																client.white_glove_service !== 'Yes, email+phone' &&
																(client.white_glove_service !== 'Free trial') & !editFlag
														"
													>
														Not Selected
													</template>
													<template v-if="editFlag">
														<div class="d-flex justify-content-center align-items-end">
															<select class="form-select border-0" v-model="client.white_glove_service">
																<option value="">Select WGS</option>
																<option value="Yes, email only">Yes, email only</option>
																<option value="Yes, email+phone">Yes, email+phone</option>
																<option value="Free trial">Free trial</option>
																<option value="no">No</option>
															</select>
															<div class="form-group">
																<label for="">Expires on</label>
																<input
																	v-if="client.white_glove_service == 'Free trial'"
																	type="date"
																	class="form-control border-0"
																	v-model="client.white_glove_service_expiration"
																/>
															</div>
														</div>
													</template>
												</p>
											</div>
										</div>

										<!-- Logo - Options free or paid -->
										<div class="col-4">
											<div class="client-editable-item mb-2">
												<p class="m-0 p-0 mt-2 fw-bold">Logo</p>
												<p class="m-0 p-0">
													<template v-if="client.logo_option && !editFlag">
														<span v-if="client.logo_option === 'Free'" class="badge badge-success bg-success">Free</span>
														<span v-if="client.logo_option === 'Paid'" class="badge badge-primary bg-primary">Paid</span>
														<span v-if="client.logo_option === 'N/A'" class="badge badge-secondary bg-secondary">N/A</span>
													</template>
													<template v-if="!client.logo_option && !editFlag">Not Selected</template>
													<template v-if="editFlag">
														<div class="d-flex justify-content-center align-items-end">
															<select class="form-select border-0" v-model="client.logo_option">
																<option value="">Select option</option>
																<option value="Free">Free</option>
																<option value="Paid">Paid</option>
																<option value="N/A">N/A</option>
															</select>
														</div>
													</template>
												</p>
											</div>
										</div>

										<!-- ADA Premium Yes or No -->
										<div class="col-4">
											<div class="client-editable-item mb-2">
												<p class="m-0 p-0 mt-2 fw-bold">ADA Premium</p>
												<p class="m-0 p-0">
													<template v-if="client.ada_premium && !editFlag">
														<span v-if="client.ada_premium === 'Yes'" class="badge badge-success bg-success">Yes</span>
														<span v-if="client.ada_premium === 'No'" class="badge badge-danger bg-danger">No</span>
													</template>
													<template v-if="!client.ada_premium && !editFlag">Not Selected</template>
													<template v-if="editFlag">
														<div class="d-flex justify-content-center align-items-end">
															<select class="form-select border-0" v-model="client.ada_premium">
																<option value="">Select option</option>
																<option value="Yes">Yes</option>
																<option value="No">No</option>
															</select>
														</div>
													</template>
												</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<!-- HeyGov -->
						<div class="card mt-2">
							<div class="card-body">
								<div class="header d-flex justify-content-between align-items-center">
									<img width="39px" src="https://assets.website-files.com/60c0bf119dbe7a93934b9782/6211ee344739a08c53957074_HeyGov%203.0.svg" />
									<div class="form-check form-switch">
										<input class="form-check-input" v-model="heygov" type="checkbox" role="button" />
									</div>
								</div>
								<div class="body" v-if="heygov">
									<!-- Contract details -->
									<div class="tw-contract-details row">
										<!-- Contract type -->
										<div class="col-md-12 mt-2">Contract details</div>
										<!-- Contract start date -->
										<div class="col-3">
											<div class="client-editable-item mb-2">
												<p class="m-0 p-0 mt-2 fw-bold">Contract start</p>
												<p class="m-0 p-0">
													<template v-if="client.hg_contract_start_at && client.hg_contract_start_at !== null && !editFlag"
														>{{ client.hg_contract_start_at | usDate }}
													</template>
													<template v-if="client.hg_contract_start_at === null && !editFlag">Not set </template>
													<template v-if="editFlag">
														<div class="d-flex justify-content-center align-items-end">
															<input type="date" class="form-control border-0" v-model="client.hg_contract_start_at" />
														</div>
													</template>
												</p>
											</div>
										</div>
										<!-- Who does billing -->
										<div class="col-3">
											<div class="client-editable-item mb-2">
												<p class="m-0 p-0 mt-2 fw-bold">Who does billing</p>
												<p class="m-0 p-0">
													<template v-if="!editFlag">
														<span v-if="client.hg_billing == 'Town Web' && !editFlag">Town Web</span>
														<span v-if="client.hg_billing == 'HeyGov' && !editFlag">HeyGov</span>
													</template>
													<template v-if="client.hg_billing === null && !editFlag">Not set </template>
													<template v-if="editFlag">
														<div class="d-flex justify-content-center align-items-end">
															<select class="form-select border-0" v-model="client.hg_billing">
																<option value="HeyGov">HeyGov</option>
																<option value="Town Web">Town Web</option>
															</select>
														</div>
													</template>
												</p>
											</div>
										</div>
									</div>
									<div class="hg-products-details row">
										<!-- HeyGov 311 -->
										<div class="col-3">
											<div class="client-editable-item mb-2">
												<p class="m-0 p-0 mt-2 fw-bold">Hey 311</p>
												<p class="m-0 p-0">
													<template v-if="!editFlag">
														<span v-if="client.heygov_311 == 'yes'" class="badge badge-success bg-success">Yes</span>
														<span v-else class="badge badge-danger bg-danger">No</span>
													</template>
													<template v-if="editFlag">
														<div class="d-flex justify-content-center align-items-end">
															<select class="form-select border-0" v-model="client.heygov_311">
																<option value="yes">Yes</option>
																<option value="no">No</option>
															</select>
														</div>
													</template>
												</p>
											</div>
										</div>
										<!-- HeyGov Reserve -->
										<div class="col-3">
											<div class="client-editable-item mb-2">
												<p class="m-0 p-0 mt-2 fw-bold">HeyReserve</p>
												<p class="m-0 p-0">
													<template v-if="!editFlag">
														<span v-if="client.heygov_reserve == 'yes'" class="badge badge-success bg-success">Yes</span>
														<span v-else class="badge badge-danger bg-danger">No</span>
													</template>
													<template v-if="editFlag">
														<div class="d-flex justify-content-center align-items-end">
															<select class="form-select border-0" v-model="client.heygov_reserve">
																<option value="yes">Yes</option>
																<option value="no">No</option>
															</select>
														</div>
													</template>
												</p>
											</div>
										</div>
										<!-- HeyGov Pay -->
										<div class="col-3">
											<div class="client-editable-item mb-2">
												<p class="m-0 p-0 mt-2 fw-bold">HeyGov Pay</p>
												<p class="m-0 p-0">
													<template v-if="!editFlag">
														<span v-if="client.heygov_pay == 'yes'" class="badge badge-success bg-success">Yes</span>
														<span v-else class="badge badge-danger bg-danger">No</span>
													</template>
													<template v-if="editFlag">
														<div class="d-flex justify-content-center align-items-end">
															<select class="form-select border-0" v-model="client.heygov_pay">
																<option value="yes">Yes</option>
																<option value="no">No</option>
															</select>
														</div>
													</template>
												</p>
											</div>
										</div>
										<!-- HeyGov License -->
										<div class="col-3">
											<div class="client-editable-item mb-2">
												<p class="m-0 p-0 mt-2 fw-bold">HeyLicense</p>
												<p class="m-0 p-0">
													<template v-if="!editFlag">
														<span v-if="client.heygov_license == 'yes'" class="badge badge-success bg-success">Yes</span>
														<span v-else class="badge badge-danger bg-danger">No</span>
													</template>
													<template v-if="editFlag">
														<div class="d-flex justify-content-center align-items-end">
															<select class="form-select border-0" v-model="client.heygov_license">
																<option value="yes">Yes</option>
																<option value="no">No</option>
															</select>
														</div>
													</template>
												</p>
											</div>
										</div>
										<!-- HeyGov ClerkMinutes -->
										<div class="col-3">
											<div class="client-editable-item mb-2">
												<p class="m-0 p-0 mt-2 fw-bold">ClerkMinutes</p>
												<p class="m-0 p-0">
													<template v-if="!editFlag">
														<span v-if="client.heygov_clerk_minutes_status == 'paid'" class="badge badge-success bg-success">Paid</span>
															<span v-else-if="client.heygov_clerk_minutes_status == 'trial'" class="badge badge-warning bg-warning">Trial</span>
															<span v-else-if="client.heygov_clerk_minutes_status == 'canceled'" class="badge badge-danger bg-danger">Canceled</span>
															<span v-else-if="client.heygov_clerk_minutes == 'yes'" class="badge badge-success bg-success">Yes</span>
														<span v-else class="badge badge-danger bg-danger">No</span>
													</template>
													<template v-if="editFlag">
														<div class="d-flex justify-content-center align-items-end">
															<select class="form-select border-0" v-model="client.heygov_clerk_minutes_status">
																<option :value="null">Not set</option>
																<option value="trial">Trial</option>
																<option value="paid">Paid</option>
																<option value="canceled">Canceled</option>
															</select>
															<input type="text" class="form-control border-0 mt-1" v-model="client.heygov_clerk_minutes_plan" placeholder="Plan" />
														</div>
													</template>
												</p>
											</div>
										</div>
										<!-- Vanteve (HeyGov AI assistant) -->
										<div class="col-3">
											<div class="client-editable-item mb-2">
												<p class="m-0 p-0 mt-2 fw-bold">Vanteve</p>
												<p class="m-0 p-0">
													<template v-if="!editFlag">
														<span v-if="client.heygov_vanteve == 'active'" class="badge badge-success bg-success">Active</span>
														<span v-else-if="client.heygov_vanteve == 'trial'" class="badge badge-warning bg-warning">Trial</span>
														<span v-else-if="client.heygov_vanteve == 'beta_tester'" class="badge badge-info bg-info">Beta tester</span>
														<span v-else-if="client.heygov_vanteve == 'canceled'" class="badge badge-danger bg-danger">Canceled</span>
														<span v-else class="badge badge-danger bg-danger">No</span>
													</template>
													<template v-if="editFlag">
														<div class="d-flex justify-content-center align-items-end">
															<select class="form-select border-0" v-model="client.heygov_vanteve">
																<option :value="null">Not set</option>
																<option value="beta_tester">Beta tester</option>
																<option value="trial">Trial</option>
																<option value="active">Active</option>
																<option value="canceled">Canceled</option>
															</select>
														</div>
													</template>
												</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<!-- ClerkMinutes (subscription model; shows even when HeyGov platform is off) -->
						<div class="card mt-2">
							<div class="card-body">
								<div class="header d-flex justify-content-between align-items-center">
									<p class="m-0 fw-bold fs-5">ClerkMinutes</p>
									<div>
										<span v-if="cmSub && cmSub.status === 'active'" class="badge bg-success">Active</span>
										<span v-else-if="cmSub && cmSub.status === 'trialing'" class="badge bg-warning text-dark">Trialing</span>
										<span v-else-if="cmSub && cmSub.status === 'lost'" class="badge bg-danger">Lost</span>
										<span v-else-if="cmSub && cmSub.status === 'cancelled_after_trial'" class="badge bg-danger">Cancelled after trial</span>
										<span v-else-if="cmSub" class="badge bg-secondary">{{ cmSub.status }}</span>
										<span v-else class="badge bg-secondary">No subscription</span>
									</div>
								</div>
								<div class="mt-2">
									<p class="p-0 m-0">Plan: <b>{{ cmSub && cmSub.plan ? cmSub.plan : '\u2014' }}</b></p>
									<p class="p-0 m-0">Ever paid: <b>{{ cmSub ? (cmSub.ever_paid === null ? 'unknown' : (cmSub.ever_paid ? 'yes' : 'no')) : '\u2014' }}</b></p>
									<p class="p-0 m-0">CM flag (heygov_clerk_minutes): <b>{{ client.heygov_clerk_minutes || 'no' }}</b></p>
								</div>
							</div>
						</div>

						<!-- Tweak Agency -->
						<div class="card mt-2">
							<div class="card-body">
								<div class="header d-flex justify-content-between align-items-center">
									<img width="95px" src="https://assets.website-files.com/5faac18aaf15d45d121eedeb/5faac29ae6b17c64ba34afd5_Tweak%20Logo%201.svg" alt="" />
									<div class="form-check form-switch">
										<input class="form-check-input" v-model="tweak" type="checkbox" role="button" />
									</div>
								</div>
								<div class="body" v-if="tweak">
									<!-- Contract details -->
									<div class="tw-contract-details row">
										<!-- Contract type -->
										<div class="col-md-12 mt-2">Contract details</div>
										<div class="col-3">
											<div class="client-editable-item mb-2">
												<p class="m-0 p-0 mt-2 fw-bold">Contract type</p>
												<p class="m-0 p-0">
													<template v-if="!editFlag">
														<template v-if="client.contract_type">{{ client.contract_type }}</template>
														<template v-if="!client.contract_type">Not set</template>
													</template>
													<template v-if="editFlag">
														<div class="d-flex justify-content-center align-items-end">
															<select class="form-select border-0" v-model="client.contract_type">
																<option value="">Select contract type</option>
																<option value="1 year">1 year</option>
																<option value="2 years">2 years</option>
																<option value="3 years">3 years</option>
																<option value="No contract">No contract</option>
															</select>
														</div>
													</template>
												</p>
											</div>
										</div>
										<!-- Contract start date -->
										<div class="col-3">
											<div class="client-editable-item mb-2">
												<p class="m-0 p-0 mt-2 fw-bold">Contract start</p>
												<p class="m-0 p-0">
													<template v-if="!editFlag">
														<template v-if="client.contract_start_at">{{ client.contract_start_at }}</template>
														<template v-if="!client.contract_start_at">Not set</template>
													</template>
													<template v-if="editFlag">
														<div class="d-flex justify-content-center align-items-end">
															<input type="date" class="form-control border-0" v-model="client.contract_start_at" />
														</div>
													</template>
												</p>
											</div>
										</div>
										<!-- Contract ends date -->
										<div class="col-3">
											<div class="client-editable-item mb-2">
												<p class="m-0 p-0 mt-2 fw-bold">Contract end</p>
												<p class="m-0 p-0">
													<template v-if="!editFlag">
														<template v-if="client.contract_ends_at">{{ client.contract_ends_at }}</template>
														<template v-if="!client.contract_ends_at">Not set</template>
													</template>
													<template v-if="editFlag">
														<div class="d-flex justify-content-center align-items-end">
															<input type="date" class="form-control border-0" v-model="client.contract_ends_at" />
														</div>
													</template>
												</p>
											</div>
										</div>
										<!-- Contract expires in -->
										<div class="col-3 d-flex justify-content-center align-items-center">
											<div class="client-editable-item mb-2 d-flex justify-content-center align-items-center">
												<p class="m-0 p-0">
													<template v-if="client.contract_ends_at !== null && client.contract_ends_at !== '0000-00-00 00:00:00'">
														<span class="badge badge-success bg-success" v-if="dateDifferenceDays(client.contract_ends_at) >= 30">
															{{ dateDifferenceDays(client.contract_ends_at) }}
															days
														</span>
														<span
															class="badge badge-warning bg-warning"
															v-if="dateDifferenceDays(client.contract_ends_at) < 30 && dateDifferenceDays(client.contract_ends_at) > 0"
														>
															{{ dateDifferenceDays(client.contract_ends_at) }}
															days
														</span>
														<span v-if="dateDifferenceDays(client.contract_ends_at) < 0" class="badge badge-danger bg-danger"> Out of contract </span>
													</template>
													<template v-else>
														<span class="badge badge-danger bg-danger"> End date missing </span>
													</template>
												</p>
											</div>
										</div>
									</div>

									<div class="row">
										<!-- Website -->
										<div class="col-8">
											<div class="client-editable-item mb-2">
												<p class="m-0 p-0 mt-2 fw-bold">Website 🌎</p>
												<p class="m-0 p-0">
													<template v-if="client.website && !editFlag">
														<a :href="client.website" target="_blank">{{ client.website }}</a>
													</template>
													<template v-if="editFlag">
														<div class="d-flex justify-content-center align-items-end">
															<input type="text" class="form-control border-0" v-model="client.website" />
														</div>
													</template>
												</p>
											</div>
										</div>

										<!-- Tweak technology -->
										<div class="col-4">
											<div class="client-editable-item mb-2">
												<p class="m-0 p-0 mt-2 fw-bold">Technology</p>
												<p class="m-0 p-0">
													<template v-if="!editFlag">
														<template v-if="client.tweak_technology">{{ client.tweak_technology }}</template>
														<template v-if="!client.tweak_technology">Not set</template>
													</template>
													<template v-if="editFlag">
														<div class="d-flex justify-content-center align-items-end">
															<select class="form-select border-0" v-model="client.tweak_technology">
																<option value="Webflow">Webflow</option>
																<option value="Wordpress">Wordpress</option>
															</select>
														</div>
													</template>
												</p>
											</div>
										</div>

										<!-- Tweak hosting plan -->
										<div class="col-4">
											<div class="client-editable-item mb-2">
												<p class="m-0 p-0 mt-2 fw-bold">Hosting</p>
												<p class="m-0 p-0">
													<template v-if="!editFlag">
														<span v-if="client.tweak_hosting == 'yes'" class="badge badge-success bg-success">Yes</span>
														<span v-if="client.tweak_hosting == 'no'" class="badge badge-danger bg-danger">No</span>
														<span v-if="!client.tweak_hosting">Not set</span>
													</template>
													<template v-if="editFlag">
														<div class="d-flex justify-content-center align-items-end">
															<select class="form-select border-0" v-model="client.tweak_hosting">
																<option value="yes">Yes</option>
																<option value="no">No</option>
															</select>
														</div>
													</template>
												</p>
											</div>
										</div>

										<!-- Tweak support -->
										<div class="col-4">
											<div class="client-editable-item mb-2">
												<p class="m-0 p-0 mt-2 fw-bold">Support</p>
												<p class="m-0 p-0">
													<template v-if="!editFlag">
														<span v-if="client.tweak_support == 'yes'" class="badge badge-success bg-success">Yes</span>
														<span v-if="client.tweak_support == 'no'" class="badge badge-danger bg-danger">No</span>
														<span v-if="!client.tweak_support">Not set</span>
													</template>
													<template v-if="editFlag">
														<div class="d-flex justify-content-center align-items-end">
															<select class="form-select border-0" v-model="client.tweak_support">
																<option value="yes">Yes</option>
																<option value="no">No</option>
															</select>
														</div>
													</template>
												</p>
											</div>
										</div>

										<!-- Tweak newsletter plan -->
										<div class="col-4">
											<div class="client-editable-item mb-2">
												<p class="m-0 p-0 mt-2 fw-bold">Newsletter</p>
												<p class="m-0 p-0">
													<template v-if="!editFlag">
														<span v-if="client.tweak_newsletter == 'yes'" class="badge badge-success bg-success">Yes</span>
														<span v-if="client.tweak_newsletter == 'no'" class="badge badge-danger bg-danger">No</span>
														<span v-if="!client.tweak_newsletter">Not set</span>
													</template>
													<template v-if="editFlag">
														<div class="d-flex justify-content-center align-items-end">
															<select class="form-select border-0" v-model="client.tweak_newsletter">
																<option value="yes">Yes</option>
																<option value="no">No</option>
															</select>
														</div>
													</template>
												</p>
											</div>
										</div>

										<!-- Theme -->
										<div class="col-4">
											<div class="client-editable-item mb-2">
												<p class="m-0 p-0 mt-2 fw-bold">Theme</p>
												<p class="m-0 p-0">
													<template v-if="!editFlag">
														<template v-if="client.theme">{{ client.theme }}</template>
														<template v-if="!client.theme">Not set</template>
													</template>
													<template v-if="editFlag">
														<div class="d-flex justify-content-center align-items-end">
															<select class="form-select border-0" v-model="client.theme">
																<option value="">Select theme</option>
																<option value="2022 Theme">2022 Theme</option>
																<option value="2022 Mini Theme">2022 Mini Theme</option>
																<option value="TW 2020">TW 2020</option>
																<option value="TW 2019">TW 2019</option>
																<option value="TW 2018">TW 2018</option>
																<option value="Rural Refined">Rural Refined</option>
																<option value="Urban Modern">Urban Modern</option>
																<option value="Reclaimed Modern">Reclaimed Modern</option>
																<option value="NY Super Theme">NY Super Theme</option>
																<option value="Rural Rustic">Rural Rustic</option>
																<option value="The Thrill is Gone - OGv5">The Thrill is Gone - OGv5</option>
																<option value="Custom Design">Custom Design</option>
																<option value="Other">Other</option>
															</select>
														</div>
													</template>
												</p>
											</div>
										</div>

										<!-- Package -->
										<div class="col-4">
											<div class="client-editable-item mb-2">
												<p class="m-0 p-0 mt-2 fw-bold">Package</p>
												<p class="m-0 p-0">
													<template v-if="!editFlag">
														<template v-if="client.package">{{ client.package }}</template>
														<template v-if="!client.package">Not set</template>
													</template>
													<template v-if="editFlag">
														<div class="d-flex justify-content-center align-items-end">
															<select class="form-select border-0" v-model="client.package">
																<option value="">Select package</option>
																<option value="Select">Select</option>
																<option value="Select Plus">Select Plus</option>
																<option value="Elite">Elite</option>
																<option value="Essential">Essential</option>
																<option value="Deluxe">Deluxe</option>
																<option value="Super Deluxe">Super Deluxe</option>
																<option value="Rural">Rural</option>
																<option value="Community Foundation">Community Foundation</option>
																<option value="Community Foundation with Payments">Community Foundation with Payments</option>
																<option value="Other">Other</option>
															</select>
														</div>
													</template>
												</p>
											</div>
										</div>

										<!-- Free redesign -->
										<div class="col-4">
											<div class="client-editable-item mb-2">
												<p class="m-0 p-0 mt-2 fw-bold">Free redesign</p>
												<p class="m-0 p-0">
													<template v-if="!editFlag">
														<span v-if="client.free_redesign == 'yes'" class="badge badge-success bg-success">Yes</span>
														<span v-if="client.free_redesign == 'no'" class="badge badge-danger bg-danger">No</span>
														<span v-if="!client.free_redesign">Not set</span>
													</template>
													<template v-if="editFlag">
														<div class="d-flex justify-content-center align-items-end">
															<select class="form-select border-0" v-model="client.free_redesign">
																<option value="yes">Yes</option>
																<option value="no">No</option>
															</select>
														</div>
													</template>
												</p>
											</div>
										</div>

										<!-- Facebook syndication -->
										<div class="col-6">
											<div class="client-editable-item mb-2">
												<p class="m-0 p-0 mt-2 fw-bold">Facebook syndication</p>
												<p class="m-0 p-0">
													<template v-if="client.facebook_syndication && !editFlag">
														<span v-if="client.facebook_syndication === 'no'" class="badge badge-danger bg-danger"> No </span>
														<span v-if="client.facebook_syndication === 'yes,not implemented'" class="badge badge-primary bg-primary">
															Yes, not implemented
														</span>
														<span v-if="client.facebook_syndication === 'yes,implemented'" class="badge badge-success bg-success">
															Yes, implemented
														</span>
													</template>
													<template v-if="editFlag">
														<div class="d-flex justify-content-center align-items-end">
															<select class="form-select border-0" v-model="client.facebook_syndication">
																<option value="">Select status</option>
																<option value="no">No</option>
																<option value="yes,not implemented">Yes, not implemented</option>
																<option value="yes,implemented">Yes, implemented</option>
															</select>
														</div>
													</template>
												</p>
											</div>
										</div>

										<!-- Branded emails -->
										<div class="col-6">
											<div class="client-editable-item mb-2">
												<p class="m-0 p-0 mt-2 fw-bold">Branded emails</p>
												<p class="m-0 p-0">
													<template v-if="client.branded_emails && !editFlag">
														<span v-if="client.branded_emails === 'no'" class="badge badge-danger bg-danger"> No </span>
														<span v-if="client.branded_emails === 'yes,not implemented'" class="badge badge-primary bg-primary">
															Yes, not implemented
														</span>
														<span v-if="client.branded_emails === 'yes,not implemented,archiving'" class="badge badge-primary bg-primary">
															Yes, not implemented
														</span>
														<span v-if="client.branded_emails === 'yes,implemented'" class="badge badge-success bg-success"> Yes, implemented </span>
														<span v-if="client.branded_emails === 'yes,implemented,archiving'" class="badge badge-success bg-success">
															Yes, implemented, archiving
														</span>
													</template>
													<template v-if="editFlag">
														<div class="d-flex justify-content-center align-items-end">
															<select class="form-select border-0" v-model="client.branded_emails">
																<option value="">Select status</option>
																<option value="no">No</option>
																<option value="yes,not implemented">Yes, not implemented</option>
																<option value="yes,not implemented">Yes,not implemented,archiving</option>
																<option value="yes,implemented">Yes, implemented</option>
																<option value="yes,implemented,archiving">Yes,implemented,archiving</option>
															</select>
														</div>
													</template>
												</p>
											</div>
										</div>

										<!-- Online payments -->
										<div class="col-6">
											<div class="client-editable-item mb-2">
												<p class="m-0 p-0 mt-2 fw-bold">Online payments</p>
												<p class="m-0 p-0">
													<template v-if="client.online_payments && !editFlag">
														<span v-if="client.online_payments === 'no'" class="badge badge-danger bg-danger"> No </span>
														<span v-if="client.online_payments === 'yes,not implemented'" class="badge badge-primary bg-primary">
															Yes, not implemented
														</span>
														<span v-if="client.online_payments === 'yes,implemented'" class="badge badge-success bg-success"> Yes, implemented </span>
													</template>
													<template v-if="editFlag">
														<div class="d-flex justify-content-center align-items-end">
															<select class="form-select border-0" v-model="client.online_payments">
																<option value="">Select status</option>
																<option value="no">No</option>
																<option value="yes,not implemented">Yes, not implemented</option>
																<option value="yes,implemented">Yes, implemented</option>
															</select>
														</div>
													</template>
												</p>
											</div>
										</div>

										<!-- Live stream -->
										<div class="col-6">
											<div class="client-editable-item mb-2">
												<p class="m-0 p-0 mt-2 fw-bold">Live stream</p>
												<p class="m-0 p-0">
													<template v-if="client.live_stream && !editFlag">
														<span v-if="client.live_stream === 'no'" class="badge badge-danger bg-danger"> No </span>
														<span v-if="client.live_stream === 'yes,not implemented'" class="badge badge-primary bg-primary">
															Yes, not implemented
														</span>
														<span v-if="client.live_stream === 'yes,implemented'" class="badge badge-success bg-success"> Yes, implemented </span>
													</template>
													<template v-if="editFlag">
														<div class="d-flex justify-content-center align-items-end">
															<select class="form-select border-0" v-model="client.live_stream">
																<option value="">Select status</option>
																<option value="no">No</option>
																<option value="yes,not implemented">Yes, not implemented</option>
																<option value="yes,implemented">Yes, implemented</option>
															</select>
														</div>
													</template>
												</p>
											</div>
										</div>

										<!-- Tweak activities -->
										<div class="col-4">
											<div class="client-editable-item mb-2">
												<p class="m-0 p-0 mt-2 fw-bold">Activities</p>
												<p class="m-0 p-0">
													<template v-if="!editFlag">
														<template v-if="client.tweak_activities">{{ client.tweak_activities }}</template>
														<template v-if="!client.tweak_activities">Not set</template>
													</template>
													<template v-if="editFlag">
														<div class="d-flex justify-content-center align-items-end">
															<select class="form-select border-0" v-model="client.tweak_activities">
																<option value="Lodging">Lodging</option>
																<option value="Dining">Dining</option>
																<option value="Art">Art</option>
																<option value="Recreation">Recreation</option>
																<option value="Contractor">Contractor</option>
																<option value="Historical Society">Historical Society</option>
																<option value="Museum">Museum</option>
																<option value="Entertainment">Entertainment</option>
																<option value="Health">Health</option>
																<option value="Fitness & Wellness">Fitness & Wellness</option>
																<option value="Legal Service">Legal Service</option>
																<option value="Financial Service">Financial Service</option>
																<option value="Personal Care">Personal Care</option>
																<option value="Home Improvement">Home Improvement</option>
																<option value="Automotive Service">Automotive Service</option>
																<option value="Cleaning Service">Cleaning Service</option>
																<option value="Real Estate Service">Real Estate Service</option>
																<option value="Security Service">Security Service</option>
																<option value="Moving Service">Moving Service</option>
																<option value="Pet & Animal Service">Pet & Animal Service</option>
																<option value="Insurance Service">Insurance Service</option>
																<option value="Construction Service">Construction Service</option>
																<option value="Postal Service">Postal Service</option>
																<option value="Child Care">Child Care</option>
																<option value="Religious Organization">Religious Organization</option>
																<option value="Shopping">Shopping</option>
																<option value="Small Business">Small Business</option>
																<option value="Tourist Agency">Tourist Agency</option>
																<option value="Sport Activity">Sport Activity</option>
																<option value="Other">Other</option>
															</select>
														</div>
													</template>
												</p>
											</div>
										</div>

										<!-- Tweak branding -->
										<div class="col-4">
											<div class="client-editable-item mb-2">
												<p class="m-0 p-0 mt-2 fw-bold">Branding</p>
												<p class="m-0 p-0">
													<template v-if="!editFlag">
														<template v-if="client.tweak_branding">{{ client.tweak_branding }}</template>
														<template v-if="!client.tweak_branding">Not set</template>
													</template>
													<template v-if="editFlag">
														<div class="d-flex justify-content-center align-items-end">
															<select class="form-select border-0" v-model="client.tweak_branding">
																<option value="Discovery">Discovery</option>
																<option value="Discover Lite">Discover Lite</option>
																<option value="Stylescapes">Stylescapes</option>
																<option value="Other">Other</option>
															</select>
														</div>
													</template>
												</p>
											</div>
										</div>

										<!-- Tweak social media marketing -->
										<div class="col-4">
											<div class="client-editable-item mb-2">
												<p class="m-0 p-0 mt-2 fw-bold">Social media marketing</p>
												<p class="m-0 p-0">
													<template v-if="!editFlag">
														<span v-if="client.tweak_social_media_marketing == 'yes'" class="badge badge-success bg-success">Yes</span>
														<span v-if="client.tweak_social_media_marketing == 'no'" class="badge badge-danger bg-danger">No</span>
														<span v-if="!client.tweak_social_media_marketing">Not set</span>
													</template>
													<template v-if="editFlag">
														<div class="d-flex justify-content-center align-items-end">
															<select class="form-select border-0" v-model="client.tweak_social_media_marketing">
																<option value="yes">Yes</option>
																<option value="no">No</option>
															</select>
														</div>
													</template>
												</p>
											</div>
										</div>

										<!-- Tweak printed marketing materials -->
										<div class="col-4">
											<div class="client-editable-item mb-2">
												<p class="m-0 p-0 mt-2 fw-bold">Printed marketing materials</p>
												<p class="m-0 p-0">
													<template v-if="!editFlag">
														<span v-if="client.tweak_printed_marketing_materials == 'yes'" class="badge badge-success bg-success">Yes</span>
														<span v-if="client.tweak_printed_marketing_materials == 'no'" class="badge badge-danger bg-danger">No</span>
														<span v-if="!client.tweak_printed_marketing_materials">Not set</span>
													</template>
													<template v-if="editFlag">
														<div class="d-flex justify-content-center align-items-end">
															<select class="form-select border-0" v-model="client.tweak_printed_marketing_materials">
																<option value="yes">Yes</option>
																<option value="no">No</option>
															</select>
														</div>
													</template>
												</p>
											</div>
										</div>

										<!-- Tweak website design -->
										<div class="col-4">
											<div class="client-editable-item mb-2">
												<p class="m-0 p-0 mt-2 fw-bold">Website design</p>
												<p class="m-0 p-0">
													<template v-if="!editFlag">
														<span v-if="client.tweak_website_design == 'yes'" class="badge badge-success bg-success">Yes</span>
														<span v-if="client.tweak_website_design == 'no'" class="badge badge-danger bg-danger">No</span>
														<span v-if="!client.tweak_website_design">Not set</span>
													</template>
													<template v-if="editFlag">
														<div class="d-flex justify-content-center align-items-end">
															<select class="form-select border-0" v-model="client.tweak_website_design">
																<option value="yes">Yes</option>
																<option value="no">No</option>
															</select>
														</div>
													</template>
												</p>
											</div>
										</div>

										<!-- Tweak Annual Profit -->
										<div class="col-8">
											<div class="client-editable-item mb-2">
												<p class="m-0 p-0 mt-2 fw-bold">Annual Profit</p>
												<p class="m-0 p-0">
													<template v-if="!editFlag">
														<template v-if="client.tweak_annual_profit">{{ client.tweak_annual_profit }}</template>
														<template v-if="!client.tweak_annual_profit">Not set</template>
													</template>
													<template v-if="editFlag">
														<div class="d-flex justify-content-center align-items-end">
															<input type="text" class="form-control border-0" v-model="client.tweak_annual_profit" />
														</div>
													</template>
												</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<!-- Hosting Only -->
						<div class="card mt-2">
							<div class="card-body">
								<div class="header d-flex justify-content-between align-items-center">
									<h5>Hosting only</h5>
									<div class="form-check form-switch">
										<input class="form-check-input" v-model="hosting" type="checkbox" role="button" />
									</div>
								</div>
							</div>
						</div>

						<!-- Action buttons -->
						<div class="d-flex justify-content-between align-items-center mt-2">
							<button class="btn btn-secondary btn-sm" @click="editFlag = !editFlag">
								<template v-if="editFlag">Disable </template>
								<template v-if="!editFlag">Enable </template>
								Edit
							</button>
							<button type="button" v-if="authUser.permissions.includes('CLIENT_UPDATE')" class="btn btn-primary float-end btn-sm" @click="updateClient()">
								Update
							</button>
						</div>
					</div>

					<!-- Feedbacks -->
					<div class="tab-pane fade" id="pills-feedback" role="tabpanel" aria-labelledby="pills-feedback-tab">
						<div v-if="feedbacks.length > 0">
							<div class="card">
								<div class="card-body">
									<div class="mb-3 row">
										<div class="col-4 d-flex justify-content-center align-items-center">
											<div class="icon me-3">
												<span style="font-size: 50px">😔</span>
											</div>
											<div class="info">
												<h3 class="mb-0">Bad</h3>
												<p class="m-0 p-0">{{ feedbacksBad }} of {{ feedbacks.length }}</p>
											</div>
										</div>
										<div class="col-4 d-flex justify-content-center align-items-center">
											<div class="icon me-3">
												<span style="font-size: 50px">🙂</span>
											</div>
											<div class="info">
												<h3 class="mb-0">Good</h3>
												<p class="m-0 p-0">{{ feedbacksGood }} of {{ feedbacks.length }}</p>
											</div>
										</div>
										<div class="col-4 d-flex justify-content-center align-items-center">
											<div class="icon me-3">
												<span style="font-size: 50px">😍</span>
											</div>
											<div class="info">
												<h3 class="mb-0">Great</h3>
												<p class="m-0 p-0">{{ feedbacksGreat }} of {{ feedbacks.length }}</p>
											</div>
										</div>
									</div>
									<span class="ms-2 pb-2">ℹ️ Note that you can click on review to go on freescout to check conversation</span>
								</div>
							</div>

							<div style="height: calc(100vh - 300px); overflow: auto" class="my-2">
								<template v-for="feedback in feedbacks">
									<div
										:key="feedback.id"
										role="button"
										class="col-12 d-flex justify-content-between p-2 px-2 rating-item mb-1 shadow rounded bg-white"
										@click="goToFreescout(feedback.conversation_id)"
									>
										<div class="d-flex align-items-center">
											<span v-if="feedback.rating === 3">😔 Bad</span>
											<span v-if="feedback.rating === 2">🙂 Good</span>
											<span v-if="feedback.rating === 1">😍 Great</span>
										</div>
										<div>{{ feedback.created_at | usDate }}</div>
									</div>
								</template>
							</div>
						</div>
						<div class="text-center bg-white" v-else>
							<div class="alert alert-warning text-center fs-6">🧑‍💻 There is still no feedback!</div>
						</div>
					</div>
					<!-- Support -->
					<div class="tab-pane fade" id="pills-support" role="tabpanel" aria-labelledby="pills-support-tab">
						<div class="text-center bg-white" v-if="conversations.length == 0">
							<div class="alert alert-warning text-center fs-6">🧑‍💻 There are no exchanged communications with this client via freescout!</div>
						</div>
						<div v-else>
							<div class="timeline timeline-inverse mt-2" style="height: calc(100vh - 300px); overflow: auto">
								<template v-for="conversation in conversations">
									<div :key="conversation.id">
										<div class="time-label">
											<span class="bg-warning text-white p-1 px-2 rounded"> 🕐 {{ conversation.last_reply_at | usDateTime }} </span>
										</div>

										<div class="timeline-item px-3 py-1 pt-2 mt-2 rounded" @click="goToFreescout(conversation.id)" role="button">
											<h4 class="timeline-header clearfix d-flex justify-content-between align-items-center">
												<span class="float-left">{{ conversation.subject }} 💬</span>
											</h4>
											<div class="timeline-body">
												{{ conversation.preview }}
											</div>
										</div>
									</div>
								</template>
								<!-- Timeline item -->
							</div>
						</div>
					</div>
					<!-- Billing -->
					<div class="tab-pane fade" id="pills-billing" role="tabpanel" aria-labelledby="pills-billing-tab">
						<div class="card">
							<div class="card-body">
								<div class="row">
									<div class="col-md-12 mb-2 d-flex justify-content-end align-items-center">
										<div class="form-check form-switch d-flex justify-content-center align-items-center me-4">
											<input
												class="form-check-input"
												@change="updateClient()"
												v-model="client.disable_dashboard"
												type="checkbox"
												role="switch"
												id="disableDashboardSwitch"
											/>
											<label class="form-check-label ms-2" for="disableDashboardSwitch">Disable Dashboard</label>
										</div>
										<div class="form-check form-switch d-flex justify-content-center align-items-center">
											<input
												class="form-check-input"
												@change="updateClient()"
												v-model="client.override_access"
												type="checkbox"
												role="switch"
												id="flexSwitchCheckDefault"
											/>
											<label class="form-check-label ms-2" for="flexSwitchCheckDefault">Allow Overdue</label>
										</div>
									</div>
									<div class="col-md-12 mb-3" v-if="domainsLoaded && (domains.length || client.website)">
										<div v-for="domain in domains" :key="domain.id" class="border rounded p-2 mb-2">
											<div class="d-flex justify-content-between align-items-center mb-1">
												<strong>🌐 {{ domain.domain }}</strong>
												<div class="d-flex align-items-center">
													<span class="badge me-2" :class="domainState(domain).cls">{{ domainState(domain).label }}</span>
													<button class="btn btn-sm btn-outline-primary" :disabled="checkingDomain" @click="checkDomainNow()">
														<font-awesome-icon v-if="checkingDomain" :icon="['fas', 'spinner']" class="fa-spin" /> Check now
													</button>
												</div>
											</div>
											<div class="row small">
												<div class="col-md-6">Registrar: {{ domain.registrar || 'unknown' }}</div>
												<div class="col-md-6">Expires: {{ domainDate(domain.expires_at) || 'unknown' }}</div>
												<div class="col-md-6">Registration: {{ domainOwner(domain) }}</div>
												<div class="col-md-6">Billed for a domain: {{ domain.billed_domain_fee || 'no invoice line names a domain' }}</div>
												<div v-if="domain.statuses" class="col-md-6">Registry status: {{ domain.statuses }}</div>
												<div v-if="domain.dns_resolves === false" class="col-md-6 text-danger">DNS does not resolve</div>
												<div class="col-md-12 text-muted">
													Checked {{ domain.last_checked_at | usDateTime }}<span v-if="domain.last_error"> · last lookup failed: {{ domain.last_error }}</span>
												</div>
											</div>
										</div>
										<div v-if="!domains.length" class="d-flex align-items-center small text-muted">
											🌐 Domain not checked yet
											<button class="btn btn-sm btn-outline-primary ms-2" :disabled="checkingDomain" @click="checkDomainNow()">
												<font-awesome-icon v-if="checkingDomain" :icon="['fas', 'spinner']" class="fa-spin" /> Check now
											</button>
										</div>
										<div v-if="domainError" class="small text-danger mt-1">{{ domainError }}</div>
									</div>
									<div class="col-md-6 mb-3">
										<div class="form-group">
											<div class="input-group">
												<span class="input-group-text" id="freshbooks-client-id-label">Freshbooks Client ID</span>
												<input
													id="freshbooks-client-id"
													type="text"
													class="form-control"
													v-model="client.freshbooks_client_id"
													@change="updateClient()"
													aria-describedby="freshbooks-client-id-label"
													:disabled="!editFlag"
												/>
												<button class="btn btn-primary" :disabled="!client.freshbooks_client_id" @click="fetchInvoices()">
													<font-awesome-icon v-if="fetchingInvoices" :icon="['fas', 'spinner']" class="fa-spin" /> Fetch Invoices
												</button>
											</div>
										</div>
									</div>
									<div class="col-12 mb-2" v-if="!loadingInvoices && client && client.invoices.length > 0">
										🙋 Note that you can see more details with click on single invoice
									</div>
									<template v-if="!loadingInvoices">
										<div :key="invoice.id" v-for="invoice in client.invoices" class="col-md-12 mb-2" @click="showInvoice(invoice)" role="button">
											<div class="row invoice-item pt-1">
												<div class="col-md-8 d-flex flex-column">
													<div class="d-flex align-items-center">
														{{ invoice.organization }}
														<span v-if="invoice.payment_status === 'paid'" class="badge badge-success bg-success ms-2">
															{{ invoice.payment_status }}
														</span>
														<span v-else class="badge badge-warning bg-warning ms-2">
															{{ invoice.payment_status }}
														</span>
													</div>
													<div>
														<pre>{{ invoice.description }}</pre>
													</div>
													<div v-for="(line, i) in invoiceLines(invoice)" :key="i" class="small text-muted">{{ line.label }} · 💰 {{ line.amount }}</div>
												</div>

												<div class="col-md-4 d-flex flex-column">
													<div class="d-flex justify-content-end mb-2">
														<div class="d-none">{{ invoice.display_status }}</div>
														<div v-if="invoice.created_at">
															<small> {{ invoice.created_at | usDate }}</small>
														</div>
														<div v-else>
															<pre style="display: contents">missing date</pre>
														</div>
													</div>
													<div class="d-flex justify-content-end align-items-start">
														<div>💰 {{ invoice.amount }}</div>
													</div>
												</div>
											</div>
										</div>
									</template>
									<div v-else class="d-flex justify-content-center">
										<div class="spinner-border" role="status">
											<span class="visually-hidden">Loading...</span>
										</div>
									</div>

									<div v-if="!loadingInvoices && client && client.invoices.length < 1" class="col-md-12">
										<div class="alert alert-warning text-center fs-5">🧑‍💻 There are no invoices on Freshbooks for this client!</div>
									</div>
									<div class="col-12 mt-3 d-flex justify-content-between align-items-center">
										<button class="btn btn-secondary btn-sm" @click="editFlag = !editFlag">
											<template v-if="editFlag">Disable </template>
											<template v-if="!editFlag">Enable </template>
											Edit
										</button>
										<button
											type="button"
											v-if="authUser.permissions.includes('CLIENT_UPDATE')"
											class="btn btn-primary btn-sm"
											:disabled="!editFlag"
											@click="updateClient()"
										>
											Update
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- Notes -->
					<div class="tab-pane fade" id="pills-notes" role="tabpanel" aria-labelledby="pills-notes-tab">
						<div class="card">
							<div class="card-body">
								<div class="row pb-2">
									<div class="col-12 d-flex justify-content-between align-items-center">
										<h5 class="mb-2">Notes</h5>
										<span>ℹ️ notes about client</span>
									</div>
								</div>
								<div v-if="clientNotes.length > 0" class="mb-3">
									<template v-for="note in clientNotes">
										<div
											:key="note.id"
											class="note-item mb-2 border-bottom py-2 d-flex justify-content-between align-items-center"
											:class="note.type === 'important' ? 'bg-danger-light' : ''"
										>
											<span class="note-item-date">{{ note.created_at | usDate }}</span>
											<p class="py-2 ms-2" style="word-break: break-all">{{ note.note }}</p>
											<div class="actions d-flex">
												<button
													data-bs-toggle="modal"
													data-bs-target="#updateNote"
													type="button"
													@click="editNote(note)"
													class="note-item-edit btn btn-sm btn-primary me-2"
												>
													<font-awesome-icon :icon="['fas', 'edit']" />
												</button>
												<button @click="deleteNote(note)" type="button" class="note-item-delete btn btn-sm btn-danger me-2">
													<font-awesome-icon :icon="['fas', 'trash']" />
												</button>
											</div>
										</div>
									</template>
								</div>
								<div v-else>
									<div class="alert alert-info text-center">There is no notes for this client</div>
								</div>
								<div class="add-note row">
									<div class="col-12">
										<div class="form-check form-check-inline">
											<input class="form-check-input" type="radio" v-model="newNote.type" id="defaultNote" value="default" />
											<label class="form-check-label" for="defaultNote">Default</label>
										</div>
										<div class="form-check form-check-inline">
											<input class="form-check-input" type="radio" v-model="newNote.type" id="devNote" value="important" />
											<label class="form-check-label" for="devNote">Important</label>
										</div>

										<textarea
											v-model="newNote.note"
											class="form-control border-0"
											:class="newNote.type === 'important' ? 'bg-danger-light' : ''"
											cols="5"
											rows="3"
											placeholder="enter your note"
										></textarea>
										<button class="btn btn-default btn-sm float-start mt-2" @click="newNote.note = ''" v-if="newNote.note.length > 3">
											<font-awesome-icon :icon="['fas', 'history']" /> clear
										</button>
										<button @click="storeNote()" class="btn btn-primary btn-sm float-end mt-2" v-if="newNote.note.length > 3">
											<font-awesome-icon :icon="['fas', 'check-circle']" /> Save note
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- DNS -->
					<!-- TODO: Check for permissions of users -->
					<div
						v-if="authUser.email.includes('srdjan') || authUser.email.includes('marta') || authUser.email.includes('marko') || authUser.email.includes('ivan')"
						class="tab-pane fade"
						id="pills-dns"
						role="tabpanel"
						aria-labelledby="pills-dns-tab"
					>
						<div class="accordion mb-2" id="accordionExample">
							<div class="accordion-item">
								<h2 class="accordion-header" id="headingThree">
									<button
										class="accordion-button collapsed"
										type="button"
										data-bs-toggle="collapse"
										data-bs-target="#collapseThree"
										aria-expanded="false"
										aria-controls="collapseThree"
									>
										DNS Settings
									</button>
								</h2>
								<div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
									<div class="accordion-body">
										<div class="form-group">
											<label for="">DNS Holder</label>
											<select class="form-select" v-model="client.dns_holder">
												<option value="">Not selected</option>
												<option value="Cloudflare">Cloudflare</option>
												<option value="Name.com">Name.com</option>
											</select>
										</div>
										<div class="form-group mb-2">
											<label for="">DNS Holder ID</label>
											<input class="form-control" type="text" v-model="client.dns_holder_id" />
										</div>

										<button type="button" v-if="authUser.permissions.includes('CLIENT_UPDATE')" class="btn btn-primary" @click="updateClient()">Update</button>
									</div>
								</div>
							</div>
						</div>

						<div v-if="!loadingDnsRecords">
							<div class="card">
								<div class="card-body">
									<div class="row" v-if="client.dns_holder">
										<div class="col-md-12">
											<div class="alert alert-primary d-flex justify-content-between align-items-center" role="alert">
												<span>👋 DNS record holder for this client is {{ client.dns_holder }}</span>
												<a v-if="client.dns_holder === 'Cloudflare'" href="https://cloudflare.com" target="_blank" class="btn btn-link text-white">
													<img src="/images/cloudflare-logo.svg" width="100" alt="" />
												</a>

												<a v-else href="https://name.com" target="_blank" class="btn btn-link text-white">
													<img src="/images/namecom-logo.svg" width="150" alt="" />
												</a>
											</div>
											<table class="table table-hover">
												<thead>
													<tr>
														<th width="70" class="text-center">Type</th>
														<th>Name</th>
														<th width="200">Content</th>
														<th width="80" class="text-center">TTL</th>
														<th width="100" class="text-center">Actions</th>
													</tr>
												</thead>
												<tbody v-if="client.dnsrecords.length > 0">
													<tr v-for="record in client.dnsrecords" :key="record.id">
														<template v-if="record.new !== undefined || record.edit !== undefined">
															<td width="100">
																<div class="form-group">
																	<select v-model="record.type" class="form-select form-select-sm">
																		<option value="A">A</option>
																		<option value="CNAME">CNAME</option>
																		<option value="MX">MX</option>
																		<option value="TXT">TXT</option>
																	</select>
																</div>
															</td>
															<td>
																<input type="text" v-model="record.name" placeholder="name" class="form-control form-control-sm" />
															</td>
															<td>
																<input type="text" v-model="record.content" placeholder="content" class="form-control form-control-sm" />
															</td>
															<td class="text-center">
																<input
																	v-model="record.ttl"
																	type="text"
																	placeholder="ttl"
																	class="form-control form-control-sm"
																	style="width: 50px"
																/>
															</td>
															<td class="text-center">
																<button @click="saveDNSRecord(record)" role="button" title="Save record" class="btn btn-success btn-circle me-1">
																	<font-awesome-icon :icon="['fas', 'check-circle']" />
																</button>
																<button
																	v-if="addingRecord"
																	role="button"
																	@click="cancelAddingRecord()"
																	title="Cancel adding record"
																	class="btn btn-info btn-circle"
																>
																	<font-awesome-icon :icon="['fas', 'times']" />
																</button>
																<button
																	v-if="editingRecord"
																	title="Cancel editing record"
																	role="button"
																	@click="cancelEditingRecord(record)"
																	class="btn btn-info btn-circle"
																>
																	<font-awesome-icon :icon="['fas', 'times']" />
																</button>
															</td>
														</template>
														<template v-else>
															<td class="text-center" style="word-break: break-word; vertical-align: middle">
																{{ record.type }}
															</td>
															<td width="150" style="word-break: break-word; vertical-align: middle">
																{{ record.name }}
															</td>
															<td style="word-break: break-word; vertical-align: middle">
																{{ record.content }}
															</td>
															<td class="text-center" style="vertical-align: middle">
																{{ record.ttl }}
															</td>
															<td class="text-center" style="vertical-align: middle">
																<button
																	v-if="!addingRecord && !editingRecord"
																	@click="editDNSRecord(record)"
																	role="button"
																	class="btn btn-primary btn-circle me-1"
																>
																	<font-awesome-icon :icon="['fas', 'pen']" />
																</button>
																<button
																	v-if="!addingRecord && !editingRecord"
																	role="button"
																	class="btn btn-danger btn-circle"
																	@click="deleteDNSRecord(record)"
																>
																	<font-awesome-icon :icon="['fas', 'times']" />
																</button>
																<span v-if="addingRecord || editingRecord"> ... </span>
															</td>
														</template>
													</tr>
												</tbody>
												<tbody v-else>
													<tr>
														<td class="text-center" colspan="5">😞 There is no DNS records for this Domain</td>
													</tr>
												</tbody>
											</table>
											<div v-if="dnsLoading" class="d-flex justify-content-center align-items-center mb-2 bg-light p-1">
												<p class="me-2 p-0 m-0">{{ dnsLoadingText }}</p>
												<div class="spinner-grow spinner-grow-sm" role="status">
													<span class="sr-only">Loading...</span>
												</div>
											</div>
											<div class="d-bloc">
												<button @click="addNewDNSRecord()" v-if="!addingRecord && !editingRecord" class="btn btn-sm btn-primary">Add new record</button>
											</div>
										</div>
									</div>
									<div v-else class="row">
										<div class="col-md-12">
											<div class="alert alert-warning d-flex justify-content-center align-items-center" role="alert">
												<span class="fs-1 me-1">🤷‍♂️</span><span class="fs-5"> We do not control this client DNS records </span>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div v-else>
							<div class="card">
								<div class="card-body">
									<div class="d-flex justify-content-center">
										<div class="spinner-border" role="status">
											<span class="sr-only">Loading...</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- Emails info -->
					<div class="tab-pane fade" id="pills-emails" role="tabpanel" aria-labelledby="pills-emails-tab">
						<div class="card">
							<div class="card-body">
								<div class="row">
									<div class="col-md-6 mb-3 d-none">
										<div class="form-group">
											<label for="">Email Users Count</label>
											<input type="number" class="form-control" v-model="client.email_users_count" />
										</div>
									</div>
									<div class="col-md-6 mb-3 d-none">
										<div class="form-group">
											<label for="">Email Users With Archiving Count</label>
											<input type="number" class="form-control" v-model="client.email_users_archiving_count" />
										</div>
									</div>

									<div class="col-md-8 mb-3 d-none">
										<div class="form-group">
											<label for=""
												>Current Annual Cost For Emails <br />
												(example1: $600.00, example2: $1,011.36)</label
											>
											<input type="text" class="form-control" v-model="client.current_annual_costs_for_emails" />
										</div>
									</div>
									<div class="col-md-6 mb-3 d-none">
										<div class="form-group">
											<label for=""
												>Future Annual Costs for Emails w/o Archiving <br />
												(example1: $600.00, example2: $1,011.36)</label
											>
											<input type="text" class="form-control" v-model="client.future_annual_costs_emails" />
										</div>
									</div>
									<div class="col-md-6 mb-3 d-none">
										<div class="form-group">
											<label for=""
												>Future Annual Costs for Emails with Archiving <br />
												(example1: $600.00, example2: $1,011.36)</label
											>
											<input type="text" class="form-control" v-model="client.future_annual_costs_archiving_emails" />
										</div>
									</div>
									<div class="col-md-6 mb-3 d-none">
										<div class="form-group">
											<label for="">Next Billing Date For Emails</label>
											<input type="date" class="form-control w-100" v-model="client.next_billing_date_for_email" />
											<input type="text" class="form-control w-100" v-model="client.next_billing_date_for_email" />
										</div>
									</div>
									<div class="col-md-6 mb-3 d-none">
										<div class="form-group">
											<label for="">Email Domain</label>
											<input type="text" class="form-control" v-model="client.email_domain" />
										</div>
									</div>
									<div class="col-md-12 mb-3 d-none">
										<div class="form-group">
											<label for=""
												>Email Usernames <br />
												(without @clientdomain.com | example: info@clientdomain.com , username is <strong> info </strong>) <br />
												(separate usernames with comma)</label
											>
											<textarea rows="3" class="form-control" v-model="client.email_usernames" />
										</div>
									</div>

									<div class="col-md-12 mb-3">
										<p>townwebsupport@clientdomain does not count as user</p>
										<label for=""
											>Name.com URL <br />
											<code>Example: <small>https://www.name.com/account/google_apps/manage/townofdexterwi.gov</small></code>
										</label>

										<div class="input-group mb-3">
											<input type="text" class="form-control" aria-label="Name.com URL" aria-describedby="name-com-url" v-model="client.email_name_com_url" />
											<a :href="client.email_name_com_url" target="_blank" class="btn btn-outline-secondary" type="button" id="name-com-url">Go</a>
										</div>
									</div>
								</div>

								<div class="w-100 mt-4">
									<button type="button" v-if="authUser.permissions.includes('CLIENT_UPDATE')" class="btn btn-primary float-end btn-sm" @click="updateClient()">
										Update
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="card mt-2" v-if="false">
					<div class="card-body">history</div>
				</div>
			</div>
		</div>
		<div v-else class="d-flex justify-content-center">
			<div class="spinner-border" role="status">
				<span class="visually-hidden">Loading...</span>
			</div>
		</div>

		<!-- Modal for updating Notes -->
		<div class="modal fade" id="updateNote" tabindex="-1" aria-labelledby="createLabel" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<form @submit.prevent="updateNote()">
						<div class="modal-header">
							<h5 class="modal-title" id="exampleModalLabel">Update note</h5>
							<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
						</div>
						<div class="modal-body">
							<div class="form-group">
								<label for="">Note</label>
								<textarea type="text" class="form-control" v-model="noteEdit.note" />
							</div>
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
							<button type="submit" class="btn btn-primary">Update</button>
						</div>
					</form>
				</div>
			</div>
		</div>

		<!-- Modal for adding Data -->
		<div class="modal fade" id="create" tabindex="-1" aria-labelledby="createLabel" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<form @submit.prevent="storeContact()">
						<div class="modal-header">
							<h5 class="modal-title" id="exampleModalLabel">New client contact</h5>
							<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
						</div>
						<div class="modal-body">
							<h3>Create Client contact</h3>
							<div class="mb-2">
								<ContactSearch v-on:setContact="setContact" />
							</div>

							<div class="form-group mb-2">
								<label for="first_name">First Name</label>
								<input type="text" class="form-control" v-model="newContact.first_name" required />
							</div>
							<div class="form-group mb-2">
								<label for="last_name">Last Name</label>
								<input type="text" class="form-control" v-model="newContact.last_name" required />
							</div>
							<div class="form-group mb-2">
								<label for="email">Email</label>
								<input type="email" class="form-control" v-model="newContact.email" required />
							</div>
							<div class="form-group mb-2">
								<label for="phone">Phone</label>
								<input type="text" class="form-control" v-model="newContact.phone" />
							</div>
							<div class="form-group mb-2">
								<label for="address">Address</label>
								<input type="text" class="form-control" v-model="newContact.address" />
							</div>
							<div class="form-group mb-2">
								<label for="title">Title</label>
								<input type="text" class="form-control" v-model="newContact.title" required />
							</div>
							<div class="form-group mb-2">
								<label for="type">Type</label>
								<input type="text" class="form-control" v-model="newContact.type" />
							</div>
							<div class="form-check form-switch mb-2 d-flex justify-content-start align-items-center">
								<input class="form-check-input" v-model="newContact.main" type="checkbox" id="main" checked />
								<label class="form-check-label ms-2" for="main">Main contact</label>
							</div>
							<div class="form-check form-switch mb-2 d-flex justify-content-start align-items-center">
								<input class="form-check-input" v-model="newContact.billing" type="checkbox" id="billingContact" checked />
								<label class="form-check-label ms-2" for="billingContact">Billing contact</label>
							</div>
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
							<button type="submit" class="btn btn-primary">Add</button>
						</div>
					</form>
				</div>
			</div>
		</div>

		<!-- Modal for preview invoice -->
		<div class="modal fade" id="previewInvoiceModal" tabindex="-1" aria-labelledby="previewInvoiceModalLabel" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<form @submit.prevent="storeContact()">
						<div class="modal-header">
							<h5 class="modal-title" id="exampleModalLabel">Invoice: {{ previewInvoice.id }}</h5>
							<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
						</div>
						<div class="modal-body">
							<div>
								<div class="d-flex justify-content-between align-items-center mb-1">
									<span>Organization:</span>
									<span>{{ previewInvoice.organization }}</span>
								</div>
								<div class="d-flex justify-content-between align-items-center mb-1">
									<span>First name:</span>
									<span>{{ previewInvoice.first_name }}</span>
								</div>
								<div class="d-flex justify-content-between align-items-center mb-1">
									<span>Last name:</span>
									<span>{{ previewInvoice.last_name }}</span>
								</div>
								<div class="">
									<h5>Invoice List</h5>
									<div class="d-flex justify-content-between align-items-start mb-1" v-for="(line, i) in invoiceLines(previewInvoice)" :key="i">
										<span>
											{{ line.label }}
											<small v-if="line.detail" class="d-block text-muted">{{ line.detail }}</small>
										</span>
										<span class="text-nowrap ms-2">💰 {{ line.amount }}</span>
									</div>
									<hr />
								</div>
								<div class="d-flex justify-content-between align-items-center mb-1">
									<span>Display status:</span>
									<span>{{ previewInvoice.display_status }}</span>
								</div>
								<div class="d-flex justify-content-between align-items-center mb-1">
									<span>Due date:</span>
									<span>{{ previewInvoice.due_date | usDate }}</span>
								</div>
								<div class="d-flex justify-content-between align-items-center mb-1">
									<span>Invoice number:</span>
									<span>{{ previewInvoice.invoice_number }}</span>
								</div>
								<div class="d-flex justify-content-between align-items-center mb-1">
									<span>Invoice ID:</span>
									<span>{{ previewInvoice.invoice_id }}</span>
								</div>
								<div class="d-flex justify-content-between align-items-center mb-1">
									<span>Payment status:</span>
									<span v-if="previewInvoice.payment_status === 'paid'" class="badge badge-success bg-success ms-2 text-uppercase">
										{{ previewInvoice.payment_status }}
									</span>
									<span v-else class="badge badge-warning bg-warning ms-2 text-uppercase">
										{{ previewInvoice.payment_status }}
									</span>
								</div>
								<div class="d-flex justify-content-between align-items-center mb-1">
									<span>Created:</span>
									<span>{{ previewInvoice.created_at | usDateTime }}</span>
								</div>
								<div class="d-flex justify-content-between align-items-center mb-1">
									<span>Amount:</span>
									<span>💰 {{ previewInvoice.amount }}</span>
								</div>
							</div>
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
						</div>
					</form>
				</div>
			</div>
		</div>

		<!-- Modal for connecting HeyGov -->
		<div class="modal fade" id="connectHeyGov" tabindex="-1" aria-labelledby="connectHeyGovModalModalLabel" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="exampleModalLabel">
							HeyGov: <span class="text-primary">{{ client.name }}</span>
						</h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						<div class="clients-search">
							<template>
								<template v-if="client.heygov_jurisdiction === null">
									<div class="form-group">
										<label for="search"> Search for client in HeyGov to connect </label>
										<input type="text" class="form-control" @input="getHeyGovMunicipalities" v-model="heyGovQuery" placeholder="Type to search for client" />
									</div>
									<div class="search-results-container position-relative">
										<div class="search-results position-absolute bg-white rounded shadow-sm" style="z-index: 999">
											<template v-if="!loadingHGclients">
												<template v-if="heygovClients && heygovClients.length > 0 && heyGovQuery && heyGovQuery.length > 2">
													<template v-for="hgClient in heygovClients">
														<div :key="hgClient.id" @click="setHGClient(hgClient)" class="search-item ps-2 pe-2 py-1 d-flex">
															<span class="me-2 w-50">{{ hgClient.name }}</span>
															<span class="me-2 w-25">{{ hgClient.location_county }}</span>
															<span class="w-25 text-end pe-2">{{ hgClient.location_state }}</span>
														</div>
													</template>
												</template>
												<template v-if="heygovClients.length === 0 && heyGovQuery.length > 2">
													<div class="d-flex flex-column justify-content-center align-items-center p-3">
														<span class="me-2 ms-2 mb-2">HeyGov Client not found!</span>
														<button
															@click="
																{
																	;(showHeyGovCreate = !showHeyGovCreate), (heyGovQuery = '')
																}
															"
															class="btn btn-primary btn-sm"
														>
															Create HeyGov client
														</button>
													</div>
												</template>
											</template>
											<template v-else>
												<div class="d-flex justify-content-center p-2">
													<font-awesome-icon :icon="['fas', 'spinner']" class="me-1 fa-spin" />
												</div>
											</template>
										</div>
									</div>
								</template>
								<template>
									<div class="d-flex justify-content-between align-items-center mt-2">
										<div>
											<div class="form-group">
												<p class="mb-0" @dblclick="addManualHeyGovFlag = !addManualHeyGovFlag">HeyGov Client</p>
												<div class="d-flex" v-if="client.heygov_jurisdiction">
													<h5 class="text-warning">{{ client.heygov_jurisdiction }}</h5>
													<a v-if="authUser.email.includes('srdjan')" href="#" @click="changeHGClient()" class="ms-3">Change</a>
												</div>
												<div v-else>
													<h5 class="text-warning">HeyGov is not set</h5>
												</div>
											</div>
										</div>
										<div class="d-flex justify-content-end align-items-start">
											<span v-if="client.heygov_key">
												Key <br />
												<span class="bg-warning-light p-1 rounded"
													><code>{{ client.heygov_key }}</code></span
												></span
											>
										</div>
									</div>
								</template>
							</template>
							<div class="manual border-1 bg-warning-lighter rounded p-2" v-if="addManualHeyGovFlag">
								<button class="btn btn-warning btn-sm d-none" @click="addManualHeyGovFlag = !addManualHeyGovFlag">HeyGov Attributes</button>
								<div v-if="addManualHeyGovFlag" class="manual-connect mt-2">
									<div class="row mb-2">
										<label class="col-sm-4 col-form-label col-form-label-sm">HeyGov Jurisdiction ID</label>
										<div class="col-sm-8">
											<input type="text" v-model="client.heygov_jurisdiction" class="form-control form-control-sm" />
										</div>
									</div>

									<div class="row mb-2">
										<label class="col-sm-4 col-form-label col-form-label-sm">HeyGov Key</label>
										<div class="col-sm-8">
											<div class="input-group mb-3">
												<input type="text" v-model="client.heygov_key" class="form-control form-control-sm" />
												<button class="btn btn-primary btn-sm border-0 shadow-sm" @click="obtainHeyGovKey()" type="button">Get Key</button>
											</div>
										</div>
									</div>

									<div class="d-flex justify-content-end">
										<button @click="updateHeyGovManual()" class="btn btn-primary btn-sm mt-2">Update</button>
									</div>
								</div>
							</div>
						</div>
						<div class="mt-3" v-if="client.heygov_jurisdiction === null">
							<div v-if="showHeyGovCreate" class="mt-3">
								<div class="row">
									<div class="col-12"><p>Select HeyGov features</p></div>
									<div v-for="(f, i) in heygovFeatures" class="col-6 col-md-3" :key="i">
										<div class="form-check">
											<input class="form-check-input" type="checkbox" v-model="heygovSelectedFeatures" :id="'feature-' + i" :value="f" />
											<label class="form-check-label" :for="'feature-' + i">{{ f }}</label>
										</div>
									</div>
								</div>
								<div @dblclick="showNewHGClientInfo = !showNewHGClientInfo" class="alert alert-info mt-3 p-2">
									ℹ️ All additional data required for the HeyGov account will be automatically collected and sent.
								</div>
								<div v-if="showNewHGClientInfo">
									<pre>
										{{ newHeyGovClient }}
									</pre
									>
								</div>
							</div>
							<div class="alert alert-danger mt-3 p-2" v-if="createJurisdictionErrors != ''">
								{{ createJurisdictionErrors }}
							</div>
						</div>
						<div class="d-flex justify-content-between align-items-center">
							<button type="button" class="btn btn-secondary d-none" data-bs-dismiss="modal">Cancel</button>
							<button class="btn btn-primary" type="button" v-if="showHeyGovCreate" @click="createHeyGovJurisdiction()" :disabled="loadingHeyGovCreate">
								<template v-if="loadingHeyGovCreate">
									<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
									Loading...
								</template>
								<template v-else> Create Jurisdiction </template>
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Modal for connecting Dropbox -->
		<div class="modal fade" id="connectDropbox" tabindex="-1" aria-labelledby="connectDropboxModalModalLabel" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<form @submit.prevent="createDropbox()" v-if="!client.dropbox">
						<div class="modal-header">
							<h5 class="modal-title" id="exampleModalLabel">
								Dropbox: <span class="text-primary">{{ client.name }}</span>
							</h5>
							<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
						</div>
						<div class="modal-body">
							<div class="form-group">
								<label for="">Dropbox Name</label>
								<input type="text" v-model="newDropbox.name" class="form-control" required />
							</div>
							<div>
								<label for="">Manager</label>
								<select class="form-select" v-model="newDropbox.manager_id" required>
									<option value="">Select Product Manager</option>
									<option value="7">Marta</option>
									<option value="13">Jerrica</option>
									<option value="23">Francine</option>
								</select>
							</div>
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
							<button type="submit" class="btn btn-primary">Create</button>
						</div>
					</form>
					<div v-else>
						<div class="modal-header">
							<h5 class="modal-title" id="exampleModalLabel">
								Dropbox: <span class="text-primary">{{ client.name }}</span>
							</h5>
							<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
						</div>
						<div class="modal-body">
							<div class="dropbox-data-info">
								<p>
									Name: <b>{{ client.dropbox.name }}</b>
								</p>
								<p>
									Skey: <b>{{ client.dropbox.skey }}</b>
								</p>
								<p>
									Size: <b>{{ client.dropbox.total_size }} MB</b>
								</p>
							</div>
							<div class="send-login-link p-3 rounded border">
								<p class="p-0 m-0 text-center border-bottom pb-2">Select contact for sending Dropbox URL</p>
								<template v-for="contact in client.contacts">
									<div :key="contact.id" class="d-flex align-items-center justify-content-between py-2">
										<span>
											{{ contact.first_name }} {{ contact.last_name }} (<small>{{ contact.email }}</small
											>)</span
										>

										<div class=""><input v-model="dropboxContacts" :value="contact.email" type="checkbox" class="cursor-pointer" /></div>
									</div>
								</template>
								<div class="my-1 d-flex justify-content-center" v-if="dropboxContacts.length > 0">
									<button class="btn btn-primary btn-sm mt-3" type="button" :disabled="sendingDropboxUrls" @click="sendDropboxUrl()">
										<template v-if="sendingDropboxUrls">
											<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
											Loading...
										</template>
										<template v-else> Send URL </template>
									</button>
								</div>
							</div>
						</div>
						<div class="modal-footer">
							<a
								target="_blank"
								:href="dropboxAppUrl + '/dropbox/' + client.dropbox_id + '/files?email=' + authUser.email + '&sauto=soflogin'"
								class="btn btn-primary btn-sm"
								>Go to Dropbox</a
							>
							<button type="button" class="btn btn-secondary btn-sm" data-bs-dismiss="modal">Close</button>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Modal for creating Juniper -->
		<div class="modal fade" id="createJuniper" tabindex="-1" aria-labelledby="connectDropboxModalModalLabel" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="exampleModalLabel">Create Juniper Instance</h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						<div v-if="!client.juniper_id">
							<!-- Client Name -->
							<div class="form-group">
								<label class="form-label">Client Name</label>
								<input type="text" class="form-control" v-model="juniperClient.name" placeholder="Client's name" />
								<small>Note: provide unique client name ( <i>example: Town of Juniper</i> ) </small>
							</div>

							<!-- Client Website URL -->
							<div class="form-group mb-3">
								<label class="form-label">Website URL</label>
								<input type="text" class="form-control" v-model="juniperClient.url" placeholder="Public URL" />
								<small>Note: this url is url for for main website not staging (<i>example: townofjuniper.com</i>) </small>
							</div>

							<!-- Staging URL is auto-generated by juniper-api after the client id is assigned (format: https://jp{id}stg.townweb.site). -->
							<div class="form-group mb-3">
								<small class="text-muted">Staging URL will be auto-generated (format: <code>jpNNNNstg.townweb.site</code>) once the client is created.</small>
							</div>

							<!-- Buttons -->
							<div class="d-flex justify-content-between align-items-center">
								<button class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
								<button @click="createJuniperSubscription()" class="btn btn-primary" type="button" :disabled="loadingJuniperCreate">
									<template v-if="!loadingJuniperCreate">Create</template>
									<template v-else>
										<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
										Creating...
									</template>
								</button>
							</div>
						</div>
						<div v-else>
							<div>
								<h5>This client has created an instance in Juniper CMS</h5>
								<br />
								<div class="d-flex justify-content-between align-items-center">
									Check client in Juniper backend
									<a :href="'/juniper/clients/edit/' + this.client.juniper_id" class="btn btn-primary">Visit in Juniper CMS</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Modal Add Onboarding -->
		<div class="modal fade" id="newOnboardingModal" tabindex="-1" aria-labelledby="newOnboardingModalLabel" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="exampleModalLabel">Create Onboarding</h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						<div v-if="!client.onboarding_id">
							<form @submit.prevent="addOnboarding">
								<div class="form-group mb-3">
									<label for="">Name</label>
									<input class="form-control" type="text" required v-model="newOnboarding.name" />
								</div>
								<div class="form-group mb-3">
									<label for="">Onboarding Type</label>
									<select class="form-select" v-model="newOnboarding.onboarding_type_id" required name="" id="">
										<option :value="type.id" v-for="type in onboardingTypes" :key="type.id">{{ type.name }}</option>
									</select>
								</div>
								<div class="form-group mb-3">
									<label for="">Description</label>
									<textarea class="form-control" v-model="newOnboarding.description" />
								</div>
								<div class="d-flex justify-content-between aligin-items-center">
									<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
									<button type="submit" class="btn btn-primary">Create Onboarding</button>
								</div>
							</form>
						</div>
						<div v-else>
							<h5>This client has created onboarding</h5>
							<br />
							<div class="d-flex justify-content-between align-items-center">
								Check onboarding data
								<a :href="'/onboarding/progress/' + this.client.onboarding_id" class="btn btn-primary">Check onboarding entries</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Modal Secure File Upload -->
		<div class="modal fade" id="secureFileUploadModal" tabindex="-1" aria-labelledby="secureFileUploadModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-xl">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="secureFileUploadModalLabel">Secure File Upload Links - {{ client.name }}</h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						<!-- Create New Link Section -->
						<div class="card mb-4">
							<div class="card-header bg-primary text-white">
								<h6 class="mb-0"><font-awesome-icon :icon="['fas', 'plus']" class="me-2" />Create New Secure Link</h6>
							</div>
							<div class="card-body">
								<form @submit.prevent="createSecureLink">
									<div class="row">
										<div class="col-md-4">
											<label class="form-label">Validity Period (days)</label>
											<input type="number" class="form-control" v-model.number="newUploadLink.validity_days" min="1" max="365" required />
										</div>
										<div class="col-md-4">
											<label class="form-label">Max Files</label>
											<input type="number" class="form-control" v-model.number="newUploadLink.max_files" min="1" max="100" required />
										</div>
										<div class="col-md-4">
											<label class="form-label">Max File Size (MB)</label>
											<input type="number" class="form-control" v-model.number="newUploadLink.max_file_size_mb" min="1" max="100" required />
										</div>
									</div>
									<div class="row mt-3">
										<div class="col-12">
											<label class="form-label">Notes (Optional)</label>
											<textarea
												class="form-control"
												v-model="newUploadLink.notes"
												rows="2"
												maxlength="1000"
												placeholder="Internal notes about this upload link..."
											></textarea>
										</div>
									</div>
									<div class="mt-3">
										<button type="submit" class="btn btn-primary" :disabled="creatingLink">
											<span v-if="creatingLink">
												<span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>Creating...
											</span>
											<span v-else> <font-awesome-icon :icon="['fas', 'link']" class="me-2" />Create Link </span>
										</button>
									</div>
								</form>
							</div>
						</div>

						<!-- Existing Links Section -->
						<div class="card">
							<div class="card-header bg-info text-white" style="cursor: pointer;" @click="showExistingLinks = !showExistingLinks">
								<div class="d-flex justify-content-between align-items-center">
									<h6 class="mb-0"><font-awesome-icon :icon="['fas', 'list']" class="me-2" />Existing Upload Links</h6>
									<font-awesome-icon :icon="['fas', showExistingLinks ? 'chevron-up' : 'chevron-down']" />
								</div>
							</div>
							<div v-show="showExistingLinks" class="card-body">
								<div v-if="loadingLinks" class="text-center py-4">
									<div class="spinner-border text-primary" role="status">
										<span class="visually-hidden">Loading...</span>
									</div>
									<p class="mt-2">Loading links...</p>
								</div>
								<div v-else-if="uploadLinks.length === 0" class="text-center py-4 text-muted">
									<font-awesome-icon :icon="['fas', 'info-circle']" class="fa-2x mb-3" />
									<p>No upload links created yet.</p>
								</div>
								<div v-else class="table-responsive">
									<table class="table table-hover">
										<thead>
											<tr>
												<th>Created</th>
												<th>Status</th>
												<th>Expires</th>
												<th>Files</th>
												<th>URL</th>
												<th>Notes</th>
												<th>Creator</th>
												<th>Actions</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="link in uploadLinks" :key="link.id">
												<td>{{ formatDate(link.created_at) }}</td>
												<td>
													<span
														class="badge"
														:class="{
															'bg-success': link.status === 'active' && link.is_active,
															'bg-danger': link.status === 'expired' || link.is_expired,
															'bg-warning': link.status === 'used',
															'bg-secondary': link.status === 'revoked',
														}"
													>
														{{ link.is_expired ? 'expired' : link.status }}
													</span>
												</td>
												<td>{{ formatDate(link.expires_at) }}</td>
												<td>
													<span class="badge bg-info"> {{ link.files_uploaded }} / {{ link.max_files }} </span>
												</td>
												<td>
													<div class="d-flex align-items-center">
														<input type="text" class="form-control form-control-sm me-2" :value="link.upload_url" readonly style="max-width: 300px;" />
														<button class="btn btn-sm btn-outline-primary" @click="copyToClipboard(link.upload_url)" title="Copy to clipboard">
															<font-awesome-icon :icon="['fas', 'copy']" />
														</button>
													</div>
												</td>
												<td>
													<span v-if="link.notes" :title="link.notes">{{ link.notes.substring(0, 30) }}{{ link.notes.length > 30 ? '...' : '' }}</span>
													<span v-else class="text-muted">-</span>
												</td>
												<td>{{ link.creator ? link.creator.name : 'Unknown' }}</td>
												<td>
													<button
														v-if="link.status === 'active' && !link.is_expired"
														class="btn btn-sm btn-warning me-1"
														@click="revokeLink(link.id)"
														title="Revoke link"
													>
														<font-awesome-icon :icon="['fas', 'ban']" />
													</button>
													<button class="btn btn-sm btn-danger" @click="deleteLink(link.id)" title="Delete link">
														<font-awesome-icon :icon="['fas', 'trash']" />
													</button>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>

						<!-- Uploaded Files Section -->
						<div class="card mt-4">
							<div class="card-header bg-success text-white">
								<h6 class="mb-0"><font-awesome-icon :icon="['fas', 'file-download']" class="me-2" />Uploaded Files</h6>
							</div>
							<div class="card-body">
								<div v-if="loadingFiles" class="text-center py-4">
									<div class="spinner-border text-primary" role="status">
										<span class="visually-hidden">Loading...</span>
									</div>
									<p class="mt-2">Loading files...</p>
								</div>
								<div v-else-if="uploadedFiles.length === 0" class="text-center py-4 text-muted">
									<font-awesome-icon :icon="['fas', 'inbox']" class="fa-2x mb-3" />
									<p>No files uploaded yet.</p>
								</div>
								<div v-else class="table-responsive">
									<table class="table table-hover">
										<thead>
											<tr>
												<th>File Name</th>
												<th>Size</th>
												<th>Uploaded</th>
												<th>Link Notes</th>
												<th>Actions</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="file in uploadedFiles" :key="file.id">
												<td>{{ file.original_name }}</td>
												<td>{{ file.file_size_human }}</td>
												<td>{{ formatDate(file.uploaded_at) }}</td>
												<td>
													<span v-if="file.link && file.link.notes">{{ file.link.notes }}</span>
													<span v-else class="text-muted">-</span>
												</td>
												<td>
													<button class="btn btn-sm btn-primary" @click="downloadFile(file.id)" title="Download file">
														<font-awesome-icon :icon="['fas', 'download']" />
													</button>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
					</div>
				</div>
			</div>
		</div>

		<Activities :key="activityKey" :subjectType="'App\\Models\\Client'" :subjectId="$route.params.id" />
		<CancellationModal
			modal-id="recordReasonModal"
			mode="reason"
			:client-id="client.id"
			:client-name="client.name"
			:subscriptions="(client && client.subscriptions) || []"
			:editing="editingSubscription"
			@saved="onReasonRecorded"
		/>

		<CancellationModal
			modal-id="removeClientModal"
			mode="removal"
			:client-id="client.id"
			:client-name="client.name"
			:subscriptions="(client && client.subscriptions) || []"
			@saved="onRemoved"
		/>
	</div>

</template>

<script>
import PageHeader from '@/components/layout/PageHeader'
import PricingQuotesCard from '@/components/pricing/PricingQuotesCard.vue'
import { mapState } from 'vuex'
import restApi from '../../api/index.js'
import juniperApi from '../../api/juniperApi.js'
import { handleErrors } from '../../actions/helpers'
import MunicipalitySearch from '@/components/municipality/MunicipalitySearch'
import { differenceInDays } from 'date-fns'
import { Modal, Tooltip } from 'bootstrap'
import ContactSearch from '@/components/contact/ContactSearch'
import Activities from '@/components/Activities'
import CancellationModal from '@/components/cancellation/CancellationModal'
import CancellationSummary from '@/components/cancellation/CancellationSummary'
import axios from 'axios'

export default {
	name: 'ClientEdit',
	components: { PageHeader, MunicipalitySearch, ContactSearch, Activities, CancellationModal, CancellationSummary, PricingQuotesCard },
	data() {
		return {
			cancellationReasonList: [],
			editingSubscription: null,
			loading: false,
			loadingJuniperCreate: false,
			loadingInvoices: false,
			fetchingInvoices: false,
			client: {
				name: 'Client',
				municipality: null,
				invoices: [],
				dnsrecords: [],
			},
			feedbacks: [],
			feedbacksGood: 0,
			feedbacksBad: 0,
			feedbacksGreat: 0,
			conversations: [],
			editFlag: false,
			newNote: {
				note: '',
				type: 'default',
			},
			clientNotes: [],
			clientInvoices: [],
			$createModal: null,
			$previewInvoiceModal: null,
			$updateNoteModal: null,
			previewInvoice: {},
			domains: [],
			domainsLoaded: false,
			checkingDomain: false,
			domainError: '',
			newContact: {
				client_id: null,
				municipality_id: null,
				contact_id: null,
				first_name: '',
				last_name: '',
				email: '',
				phone: '',
				email_secondary: '',
				phone_secondary: '',
				address: '',
				title: '',
				source: 'mc2',
				main: 0,
				billing: 0,
				first_training_date: null,
				type: '',
			},
			activityKey: 0,
			newDNSRecord: {
				type: 'A',
				name: '',
				content: '',
				ttl: 1,
				new: true,
			},
			addingRecord: false,
			editingRecord: false,
			eRecord: null,
			dnsLoadingText: 'Loading',
			dnsLoading: false,
			loadingDnsRecords: false,
			tweak: false,
			heygov: false,
			townweb: false,
			hosting: false,
			servers: {
				'Rackspace RS1': '161.47.89.78',
				'Hetzner DS3': '138.201.199.88',
				'Hetzner DS2': '46.4.50.219',
				'Hetzner DS4': '176.9.158.45',
				'DigitalOcean DO1': '162.243.184.78',
				'AWS WEDC': '34.216.252.96',
				'DigitalOcean DO18': '104.131.73.154',
				'AWS LS1': '18.219.87.118',
			},
			noteEdit: {
				id: '',
				note: '',
			},
			dashboardWeatherFlag: false,
			twWeatherActive: false,
			loadingWeather: false,
			$connectHeyGovModal: null,
			$connectDropboxModal: null,
			$createJuniperModal: null,
			heyGovQuery: '',
			heygovClients: [],
			loadingHGclients: false,
			showHeyGovCreate: false,
			newDropbox: {
				name: '',
				manager_id: null,
				client_id: null,
				status: 'Active',
				heygov_jurisdiction: '',
				heygov_key: '',
			},
			creatingDropbox: false,
			dropboxAppUrl: process.env.VUE_APP_DROPBOX_URL,
			dropboxContacts: [],
			sendingDropboxUrls: false,
			newHeyGovClient: {},
			heygovFeatures: ['events', 'meetings', 'issues', 'forms', 'venues', 'payments'],
			heygovSelectedFeatures: ['events', 'meetings'],
			loadingHeyGovCreate: false,
			createJurisdictionErrors: '',
			showNewHGClientInfo: false,
			addManualHeyGovFlag: false,
			juniperClient: {
				name: '',
				url: '',
				mc_client_id: this.$route.params.id,
			},
			newOnboarding: {
				name: '',
				description: '',
				client_id: null,
				municipality_id: null,
				onboarding_type_id: null,
			},
			onboardingTypes: [],
			$newOnboardingModal: null,
			heyGovAPIUrl: process.env.VUE_APP_HEYGOV_API_URL,
			HeyGovMeiliUrl: process.env.VUE_APP_HEYGOV_MAILISEARCH,
			// Secure File Upload
			uploadLinks: [],
			uploadedFiles: [],
			loadingFiles: false,
			loadingLinks: false,
			showExistingLinks: false,
			creatingLink: false,
			newUploadLink: {
				validity_days: 10,
				max_files: 10,
				max_file_size_mb: 25,
				notes: '',
			},
			$secureFileUploadModal: null,
			// Intercom Sync
			syncingIntercom: false,
		}
	},
	computed: {
		...mapState(['authUser', 'storageUrl', 'token']),
		cmSub() {
			const subs = (this.client && this.client.subscriptions) || []
			return subs.find(s => s.brand && s.brand.key === 'clerkminutes' && !s.superseded_by_id) || null
		},
	},
	created() {
		setTimeout(() => {
			document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(el => {
				new Tooltip(el)
			})
		}, 1100)
		this.getClient()
		this.loadCancellationReasons()
		this.getOnboartingTypes()
	},
	mounted() {
		this.$createModal = new Modal('#create')
		this.$updateNoteModal = new Modal('#updateNote')
		this.$previewInvoiceModal = new Modal('#previewInvoiceModal')
		this.$connectHeyGovModal = new Modal('#connectHeyGov')
		this.$cancellationModal = new Modal('#removeClientModal')
		this.$recordReasonModal = new Modal('#recordReasonModal')
		this.$connectDropboxModal = new Modal('#connectDropbox')
		this.$createJuniperModal = new Modal('#createJuniper')
		this.$newOnboardingModal = new Modal('#newOnboardingModal')
		this.$secureFileUploadModal = new Modal('#secureFileUploadModal')
	},
	methods: {
		// Get Client
		getClient() {
			restApi
				.get(`/clients/${this.$route.params.id}`)
				.then(({ data }) => {
					this.client = data
					this.newContact.municipality_id = data.municipality_id
					this.newContact.client_id = data.id
					if (this.client.tw_weather == 'yes') {
						this.twWeatherActive = true
					}
					this.checkServices()
					this.getClientFeedbacks()
					this.getClientConversations()
					this.getNotes()
					this.getClientDnsRecords()
					this.getClientDomains()
					this.setServer()
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},

		// Update Invoices from Freshbooks
		fetchInvoices() {
			this.fetchingInvoices = true
			restApi
				.get(`freshbooks/invoices/fetch/${this.$route.params.id}`)
				.then(({ data }) => {
					console.log(data)
					this.getClient()
					this.fetchingInvoices = false
				})
				.catch(error => {
					this.fetchingInvoices = false
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},

		// Get all client feedbacks from Freescout
		getClientFeedbacks() {
			restApi
				.post(`/clients/feedbacks`, { id: this.client.id })
				.then(({ data }) => {
					this.feedbacks = data
					this.feedbacks.forEach(feedback => {
						if (feedback.rating === 1) {
							this.feedbacksGreat = this.feedbacksGreat + 1
						}
						if (feedback.rating === 2) {
							this.feedbacksGood = this.feedbacksGood + 1
						}
						if (feedback.rating === 3) {
							this.feedbacksBad = this.feedbacksBad + 1
						}
					})
				})
				.catch(error => {
					console.error(error)
					/* this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					}) */
				})
		},

		// Get all client conversations from Freescout
		getClientConversations() {
			restApi
				.post(`/clients/conversations`, { id: this.client.id })
				.then(({ data }) => {
					this.conversations = data
				})
				.catch(error => {
					console.error(error)
					/* this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					}) */
				})
		},

		// Update Client
		updateClient() {
			restApi
				.put(`/clients/${this.$route.params.id}`, this.client)
				.then(({ data }) => {
					this.client = data
					//this.client.invoices = []
					this.checkServices()
					this.getClientFeedbacks()
					this.getClientConversations()
					this.getNotes()
					this.getClientDnsRecords()
					this.setServer()
					// this.activityKey++
					this.$swal.fire({
						icon: 'success',
						title: 'Client successfully updated!',
						timer: 3000,
					})
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},

		// Set municipality for client if client is municipality type
		setMunicipality(municipality) {
			if (municipality !== null) {
				this.client.municipality_id = municipality.id
				this.updateClient()
				this.getClient()
			} else {
				this.client.municipality_id = ''
			}
		},

		dateDifferenceDays(date) {
			return differenceInDays(new Date(date), new Date())
		},

		goToFreescout(conversationId) {
			window.open('https://fs2022.townweb.com/conversation/' + conversationId, '_blank')
		},

		// Get notes for current client
		getNotes() {
			restApi
				.get(`/clients/${this.$route.params.id}/notes`)
				.then(({ data }) => {
					this.clientNotes = data
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},

		storeNote() {
			this.newNote.user_id = this.authUser.id
			this.newNote.client_id = this.client.id

			restApi
				.post(`/clients/${this.client.id}/notes`, this.newNote)
				.then(({ data }) => {
					this.$swal.fire({
						icon: 'success',
						title: 'Client note successfully created!',
						timer: 3000,
					})

					this.clientNotes = [data].concat(this.clientNotes)

					this.newNote = {
						note: '',
						type: 'default',
					}
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},

		deleteNote(note) {
			this.$swal
				.fire({
					title: 'Are you sure?',
					text: "You won't be able to revert this!",
					icon: 'warning',
					position: 'center',
					showCancelButton: true,
					showConfirmButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes, delete it!',
					toast: false,
					timer: 0,
				})
				.then(result => {
					if (result.isConfirmed) {
						restApi
							.delete(`/clients/${this.client.id}/notes/${note.id}`)
							.then(() => {
								this.getNotes()
								this.$swal.fire({
									icon: 'success',
									title: 'Note successfully removed!',
								})
							})
							.catch(error => {
								this.$swal.fire({
									icon: 'error',
									title: handleErrors(error, ''),
									timer: 6000,
								})
							})
					}
				})
		},

		deleteContact(contact) {
			this.$swal
				.fire({
					title: 'Are you sure?',
					text: "You won't be able to revert this!",
					icon: 'warning',
					position: 'center',
					showCancelButton: true,
					showConfirmButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes, delete it!',
					toast: false,
					timer: 0,
				})
				.then(result => {
					if (result.isConfirmed) {
						restApi
							.delete(`/client-contacts/` + contact.id)
							.then(() => {
								this.client.contacts = this.client.contacts.filter(c => contact.id !== c.id)
								this.$swal.fire({
									icon: 'success',
									title: 'Contact successfully removed!',
									timer: 3000,
								})
							})
							.catch(error => {
								this.$swal.fire({
									icon: 'error',
									title: handleErrors(error, ''),
									timer: 6000,
								})
							})
					}
				})
		},

		setContact(contact) {
			if (contact !== null) {
				this.newContact.contact_id = contact.id
				this.newContact.first_name = contact.first_name
				this.newContact.last_name = contact.last_name
				this.newContact.email = contact.email
				this.newContact.phone = contact.phone
				this.newContact.email_secondary = contact.email_secondary
				this.newContact.address = contact.address
				this.newContact.title = contact.title
				this.newContact.main = contact.main
				this.newContact.type = contact.type
			} else {
				this.newContact.contact_id = null
				this.newContact.first_name = ''
				this.newContact.last_name = ''
				this.newContact.email = ''
				this.newContact.phone = ''
				this.newContact.email_secondary = ''
				this.newContact.address = ''
				this.newContact.title = ''
				this.newContact.main = ''
				this.newContact.type = ''
			}
		},

		storeContact() {
			// If client is not municipal
			if (this.newContact.municipality_id === null) {
				// Store client contact to client contacts table its non municipal client
				restApi
					.post(`/client-contacts`, this.newContact)
					.then(({ data }) => {
						this.newContact.contact_id = data.id
						this.$createModal.hide()
						this.cancelAddingClient()
						this.getClient()
						this.$swal.fire({
							icon: 'success',
							title: 'Contact successfully created!',
							timer: 3000,
						})
					})
					.catch(error => {
						this.$swal.fire({
							icon: 'error',
							title: handleErrors(error, ''),
							timer: 6000,
						})
					})
			} else {
				if (this.newContact.contact_id === null) {
					// Create new contact in Contacts table and in Client contacts
					restApi
						.post(`/contacts`, this.newContact)
						.then(({ data }) => {
							this.$createModal.hide()
							this.newContact.contact_id = data.id
							restApi
								.post(`/client-contacts`, this.newContact)
								.then(() => {
									this.cancelAddingClient()
									this.getClient()
									this.$swal.fire({
										icon: 'success',
										title: 'Contact successfully created!',
										timer: 3000,
									})
								})
								.catch(error => {
									this.$swal.fire({
										icon: 'error',
										title: handleErrors(error, ''),
										timer: 6000,
									})
								})
						})
						.catch(error => {
							this.$swal.fire({
								icon: 'error',
								title: handleErrors(error, ''),
								timer: 6000,
							})
						})
				} else {
					// Update contact in Contacts table and create new contact in client table
					restApi
						.post(`/client-contacts`, this.newContact)
						.then(() => {
							this.$createModal.hide()
							restApi
								.put(`/contacts/${this.newContact.contact_id}`, this.newContact)
								.then(() => {
									this.cancelAddingClient()
									this.getClient()
									this.$swal.fire({
										icon: 'success',
										title: 'Contact successfully created!',
										timer: 3000,
									})
								})
								.catch(error => {
									this.$swal.fire({
										icon: 'error',
										title: handleErrors(error, ''),
										timer: 6000,
									})
								})
						})
						.catch(error => {
							this.$swal.fire({
								icon: 'error',
								title: handleErrors(error, ''),
								timer: 6000,
							})
						})
				}
			}
		},

		cancelAddingClient() {
			this.newContact.municipality_id = this.client.municipality_id
			this.newContact.client_id = this.client.id
			this.newContact.contact_id = null
			this.newContact.first_name = ''
			this.newContact.last_name = ''
			this.newContact.email = ''
			this.newContact.phone = ''
			this.newContact.email_secondary = ''
			this.newContact.address = ''
			this.newContact.title = ''
			this.newContact.main = ''
			this.newContact.type = ''
		},

		showInvoice(invoice) {
			try {
				invoice.items = JSON.parse(invoice.items)
				console.log('Valid JSON')
			} catch (e) {
				console.log('Not valid JSON')
			}
			//invoice.items = JSON.parse(invoice.items)
			this.previewInvoice = invoice
			this.$previewInvoiceModal.show()
		},

		// FreshBooks lines of an invoice. items comes as a JSON string (showInvoice parses it in place, so arrays too);
		// the label is in name, older rows only have description
		invoiceLines(invoice) {
			let items = invoice && invoice.items
			if (typeof items === 'string') {
				try {
					items = JSON.parse(items)
				} catch (e) {
					items = []
				}
			}
			return (Array.isArray(items) ? items : []).map(item => {
				const name = (item.name || '').trim()
				const description = (item.description || '').trim()
				const qty = Number(item.qty)
				return {
					label: name || description || 'Line item',
					detail: [name && description ? description : '', qty && qty !== 1 && item.unit_cost ? `${qty} × ${item.unit_cost}` : ''].filter(Boolean).join(' · '),
					amount: item.amount,
				}
			})
		},

		// Domain card: registrar, expiry and whether the domain is in our Name.com or Cloudflare, from the daily domains:check-expiry
		getClientDomains() {
			restApi
				.get(`/clients/${this.$route.params.id}/domains`)
				.then(({ data }) => {
					this.domains = data
					this.domainsLoaded = true
				})
				.catch(() => {
					// the card stays hidden until the API has the endpoint
					this.domains = []
					this.domainsLoaded = false
				})
		},

		// looks the domain up again; the API never emails or posts to Slack from here
		checkDomainNow() {
			this.checkingDomain = true
			this.domainError = ''
			restApi
				.post(`/clients/${this.$route.params.id}/domains/check`)
				.then(({ data }) => {
					this.domains = data
					this.checkingDomain = false
				})
				.catch(error => {
					this.checkingDomain = false
					this.domainError = handleErrors(error, 'The domain lookup failed')
				})
		},

		domainDays(domain) {
			if (!domain.expires_at) return null
			const [y, m, d] = domain.expires_at.slice(0, 10).split('-').map(Number)
			const now = new Date()
			return Math.round((Date.UTC(y, m - 1, d) - Date.UTC(now.getFullYear(), now.getMonth(), now.getDate())) / 86400000)
		},

		// a plain date, no timezone shift (new Date('2027-11-01') is Oct 31 in US time)
		domainDate(value) {
			if (!value) return ''
			const [y, m, d] = value.slice(0, 10).split('-')
			return `${m}/${d}/${y}`
		},

		domainState(domain) {
			const statuses = (domain.statuses || '').toLowerCase()
			const days = this.domainDays(domain)
			if (['client hold', 'server hold', 'redemption period', 'pending delete', 'inactive'].some(s => statuses.includes(s)) || (days !== null && days < 0)) {
				return { label: 'Lapsed', cls: 'bg-danger' }
			}
			if (days !== null && days <= 60) return { label: `Expires in ${days} days`, cls: 'bg-warning text-dark' }
			return { label: 'OK', cls: 'bg-success' }
		},

		domainOwner(domain) {
			return { townweb: 'In our Name.com or Cloudflare', client: 'Not in our Name.com or Cloudflare', gov: 'get.gov' }[domain.managed_by] || 'Not confirmed yet'
		},

		addNewDNSRecord() {
			this.client.dnsrecords.push(this.newDNSRecord)
			this.addingRecord = true
		},

		editDNSRecord(record) {
			this.eRecord = JSON.stringify(record)
			this.client.dnsrecords = this.client.dnsrecords.filter(r => {
				if (r.id === record.id) {
					r.edit = true
				}
				return r
			})
			this.editingRecord = true
		},

		cancelAddingRecord() {
			this.client.dnsrecords = this.client.dnsrecords.filter(r => r.id !== undefined)
			this.addingRecord = false
		},

		cancelEditingRecord(record) {
			this.client.dnsrecords = this.client.dnsrecords.filter(r => {
				if (r.id === record.id) {
					delete r.edit
					r.type = JSON.parse(this.eRecord).type
					r.name = JSON.parse(this.eRecord).name
					r.content = JSON.parse(this.eRecord).content
					r.ttl = JSON.parse(this.eRecord).ttl
				}
				return r
			})
			this.editingRecord = false
		},

		saveDNSRecord(record) {
			this.dnsLoading = true
			if (this.addingRecord) {
				// Store record
				this.dnsLoadingText = 'Saving DNS record'
				record.client_id = this.client.id
				restApi
					.post(`/dns-records/` + record.id, record)
					.then(({ data }) => {
						this.client.dnsrecords = this.client.dnsrecords.filter(r => {
							if (r.id === record.id) {
								delete r.new
								r.id = data.id
								r.name = data.name
								r.type = data.type
								r.content = data.content
								r.ttl = data.ttl
								r.zone_id = data.zone_id
								r.created_at = data.created_at
								r.updated_at = data.updated_at
								r.dns_record_id = data.dns_record_id
							}
							return r
						})
						this.addingRecord = false
						this.newDNSRecord = {
							type: 'A',
							name: '',
							content: '',
							ttl: 1,
							new: true,
						}
						this.dnsLoading = false
						this.$swal.fire({
							icon: 'success',
							title: 'Record successfully created!',
						})
					})
					.catch(error => {
						this.dnsLoading = false
						this.$swal.fire({
							icon: 'error',
							title: error.response.data.message,
							timer: 6000,
						})
					})
			} else {
				// Update record
				this.dnsLoadingText = 'Updating DNS record'
				restApi
					.put(`/dns-records/` + record.id, record)
					.then(() => {
						this.client.dnsrecords = this.client.dnsrecords.filter(r => {
							if (r.id === record.id) {
								delete r.edit
							}
							return r
						})
						this.editingRecord = false
						this.dnsLoading = false
						this.$swal.fire({
							icon: 'success',
							title: 'Record successfully updated!',
						})
					})
					.catch(error => {
						this.dnsLoading = false
						this.$swal.fire({
							icon: 'error',
							title: error.response.data.message,
							timer: 6000,
						})
					})
			}
		},

		deleteDNSRecord(record) {
			this.$swal
				.fire({
					title: 'Are you sure?',
					text: "You won't be able to revert this!",
					icon: 'warning',
					position: 'center',
					showCancelButton: true,
					showConfirmButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes, delete it!',
					toast: false,
					timer: 0,
				})
				.then(result => {
					if (result.isConfirmed) {
						this.dnsLoading = true
						this.dnsLoadingText = 'Removing DNS record'
						restApi
							.delete(`/dns-records/` + record.id)
							.then(() => {
								this.client.dnsrecords = this.client.dnsrecords.filter(r => r.id !== record.id)
								this.dnsLoading = false
								this.$swal.fire({
									icon: 'success',
									title: 'Record successfully deleted!',
								})
							})
							.catch(error => {
								this.dnsLoading = false
								this.$swal.fire({
									icon: 'error',
									title: error.response.data.message,
									timer: 6000,
								})
							})
					}
				})
		},

		getClientDnsRecords() {
			this.loadingDnsRecords = true
			restApi
				.post(`dns-records/client/` + this.client.id)
				.then(({ data }) => {
					this.client.dnsrecords = data
					this.loadingDnsRecords = false
				})
				.catch(error => {
					this.loadingDnsRecords = true
					this.$swal.fire({
						icon: 'error',
						title: error.response.data.message,
						timer: 6000,
					})
				})
		},

		// Remove client. The confirm dialog used to be a one-line "are you sure" that also said
		// the removal could not be reverted, which was never true: it is a soft delete. It now asks
		// WHY, because that answer is the only record we get of a customer leaving.
		removeClient() {
			this.$cancellationModal.show()
		},

		openReasonModal(subscription) {
			this.editingSubscription = subscription || null
			this.$nextTick(() => this.$recordReasonModal.show())
		},

		onReasonRecorded() {
			this.$recordReasonModal.hide()
			this.editingSubscription = null
			this.getClient()
			this.$swal.fire({ icon: 'success', title: 'Reason recorded', timer: 2000 })
		},

		loadCancellationReasons() {
			restApi
				.get('/cancellations/options')
				.then(res => {
					this.cancellationReasonList = res.data.reasons || []
				})
				.catch(() => {})
		},

		onRemoved(message) {
			this.$cancellationModal.hide()
			this.$router.push('/clients')
			this.$swal.fire({ icon: 'success', title: message || 'Client removed', timer: 3000 })
		},

		// Check services for client (HeyGov, TownWeb, Tweak, Hosting only)
		checkServices() {
			if (this.client.hg_client === 'yes') {
				this.heygov = true
			} else {
				this.heygov = false
			}
			if (this.client.tw_client === 'yes') {
				this.townweb = true
			} else {
				this.townweb = false
			}
			if (this.client.tk_client === 'yes') {
				this.tweak = true
			} else {
				this.tweak = false
			}
			if (this.client.hosting === 'yes') {
				this.hosting = true
			} else {
				this.hosting = false
			}
		},

		setServer() {
			this.client.server_ip = this.servers[this.client.server]
		},

		editNote(note) {
			console.log(note)
			this.noteEdit = note
		},

		updateNote() {
			restApi
				.put(`/clients/${this.client.id}/notes/${this.noteEdit.id}`, this.noteEdit)
				.then(() => {
					this.$updateNoteModal.hide()
					this.$swal.fire({
						icon: 'success',
						title: 'Client note successfully updated!',
						timer: 3000,
					})
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},

		updateWeather() {
			this.loadingWeather = true
			restApi
				.post(`/clients/${this.client.id}/update-weather`, this.noteEdit)
				.then(() => {
					this.loadingWeather = false
					this.$swal.fire({
						icon: 'success',
						title: 'Weather successfully updated!',
						timer: 3000,
					})
				})
				.catch(error => {
					console.log(error.response.data.message)
					this.loadingWeather = false
					this.$swal.fire({
						icon: 'error',
						title: error.response.data.message,
						timer: 6000,
					})
				})
		},

		showHeyGovModal() {
			this.showHeyGovCreate = false
			this.newHeyGovClient = {
				name: this.client.name,
				slug: this.removeProtocol(this.client.website),
				type: this.client?.municipality?.type ? this.client.municipality.type.toLowerCase() : 'other',
				email: this.client.email,
				website: this.client.website,
				location: {
					lat: this.client.latitude,
					lng: this.client.longitude,
					city: this.client.city,
					county: this.client.county,
					state: this.client.state_abb,
					country: 'US',
				},
				features: this.heygovSelectedFeatures,
			}

			this.$connectHeyGovModal.show()
		},

		showDropboxModal() {
			let urlObj = new URL(this.client.website)
			this.newDropbox.name = this.client.name
			this.newDropbox.skey = urlObj.hostname
			this.newDropbox.client_id = this.client.id
			this.newDropbox.heygov_jurisdiction = this.client.heygov_jurisdiction
			this.newDropbox.heygov_key = this.client.heygov_key
			this.newDropbox.juniper_id = this.client.juniper_id
			this.$connectDropboxModal.show()
		},

		/**
		 * Get HeyGov Jurisdictions from MeiliSearch
		 */
		getHeyGovMunicipalities() {
			const config = {
				headers: {
					Authorization: `Bearer 4e05a4b370c797e1cb930c82f803ea90927736c4b7c7c58eb8d5b5df6a58ad0b`,
				},
			}
			let qry = ''
			if (this.heyGovQuery) {
				qry = '&q=' + this.heyGovQuery
			}
			if (this.heyGovQuery && this.heyGovQuery.length > 2) {
				this.loadingHGclients = true
				axios
					.get(this.HeyGovMeiliUrl + '/indexes/heygov-jurisdictions-prod/search?limit=10000' + qry, config)
					.then(response => {
						this.heygovClients = response.data.hits
						this.loadingHGclients = false
					})
					.catch(error => {
						this.loadingHGclients = false
						console.error('Error making request:', error)
					})
			} else {
				this.loadingHGclients = false
				this.heygovClients = []
			}
		},

		setHGClient(hgclient) {
			this.client.heygov_jurisdiction = hgclient.slug
			this.heyGovQuery = ''
			this.heygovClients = []
		},

		changeHGClient() {
			this.client.heygov_jurisdiction = null
			this.client.heygov_key = null
		},

		createDropbox() {
			this.creatingDropbox = true
			restApi
				.post('/dropbox', this.newDropbox)
				.then(({ data }) => {
					this.creatingDropbox = false
					this.client.dropbox_id = data.id
					this.updateClient()
					this.$connectDropboxModal.hide()
					this.$swal.fire({
						icon: 'success',
						title: 'Dropbox is created!',
					})
					this.getClient()
				})
				.catch(error => {
					this.creatingDropbox = false
					this.$swal.fire({
						icon: 'error',
						title: error.response.data.message,
						timer: 6000,
					})
				})
		},

		sendDropboxUrl() {
			this.sendingDropboxUrls = true
			let props = {
				emails: this.dropboxContacts,
				dropbox_id: this.client.dropbox_id,
			}

			restApi
				.post('/dropbox/mail/login-details', props)
				.then(({ data }) => {
					console.log(data)
					this.$swal.fire({
						icon: 'success',
						title: 'Emails sent!',
					})
					this.dropboxContacts = []
					this.sendingDropboxUrls = false
					this.$connectDropboxModal.hide()
				})
				.catch(error => {
					this.sendingDropboxUrls = false
					this.$swal.fire({
						icon: 'error',
						title: error.response.data.message,
						timer: 6000,
					})
				})
		},

		removeProtocol(url) {
			url = url.replace(/(^\w+:|^)\/\//, '')
			url = url.replace(/\/$/, '')
			return url
		},

		createHeyGovJurisdiction() {
			this.loadingHeyGovCreate = true
			const config = {
				headers: {
					Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6NjY2LCJlbWFpbCI6InN1cHBvcnRAdG93bndlYi5jb20iLCJuYW1lIjoiVG93bldlYiIsImlhdCI6MTcyMzAyMjkzMH0.X8TchSfjcSWuFRTyTcYxEDlG1EhyzN_HYEeYfaudBWs`,
					Origin: 'https://app.heygov.com',
				},
			}
			axios
				.post(this.heyGovAPIUrl + '/jurisdictions?source=mission-control', this.newHeyGovClient, config)
				.then(({ data }) => {
					this.loadingHeyGovCreate = false
					this.$swal
						.fire({
							icon: 'success',
							title: 'HeyGov successfully created!',
							timer: 3000,
						})
						.then(() => {
							this.updateClient()
						})
					this.client.heygov_jurisdiction = data.slug
					// Get API key
					axios
						.get(this.heyGovAPIUrl + '/' + this.client.heygov_jurisdiction + '/api-keys/secret-endpoint-for-townweb-key', {}, config)
						.then(({ data }) => {
							this.loadingHeyGovCreate = false
							this.$swal
								.fire({
									icon: 'success',
									title: 'HeyGov Key obtained!',
									timer: 3000,
								})
								.then(() => {
									this.updateClient()
								})
							this.client.heygov_key = data.key
							// Get API key
							this.$connectHeyGovModal.hide()
						})
						.catch(error => {
							this.loadingHeyGovCreate = false
							this.createJurisdictionErrors = '⚠️ ' + error.response.data.message
							console.error('Error making request:', error)
						})

					this.$connectHeyGovModal.hide()
				})
				.catch(error => {
					this.loadingHeyGovCreate = false
					this.createJurisdictionErrors = '⚠️ ' + error.response.data.message
					console.error('Error making request:', error)
				})
		},

		obtainHeyGovKey() {
			// Get API key
			axios
				.get(this.heyGovAPIUrl + '/' + this.client.heygov_jurisdiction + '/api-keys/secret-endpoint-for-townweb-key')
				.then(({ data }) => {
					this.client.heygov_key = data.key
				})
				.catch(error => {
					this.createJurisdictionErrors = '⚠️ ' + error.response.data.message
					console.error('Error making request:', error)
				})
		},

		updateHeyGovManual() {
			this.updateClient()
			this.$connectHeyGovModal.hide()
		},

		showJuniperCreationModal() {
			this.juniperClient.name = this.client.name
			this.juniperClient.url = this.client.website
			this.$createJuniperModal.show()
		},

		// Create Subscription for client.
		// New provisioning flow:
		//   1. juniper-api POST /clients         → creates record, assigns id, generates staging_url
		//   2. mc2-api   POST /juniper/...       → provisions Plesk + Cloudflare using that staging_url
		//   3. juniper-api POST /clients/{id}/credentials → persist FTP creds
		// If step 2 fails the juniper record stays with status='preparing' for cleanup.
		async createJuniperSubscription() {
			this.loadingJuniperCreate = true

			let juniperClient
			try {
				const { data } = await juniperApi.post('/clients', {
					name: this.juniperClient.name,
					url: this.juniperClient.url,
					mc_client_id: this.juniperClient.mc_client_id,
				})
				juniperClient = data
			} catch (error) {
				this.loadingJuniperCreate = false
				this.$swal.fire({
					icon: 'error',
					title: this.extractJuniperError(error, 'Failed to create Juniper client record'),
					timer: 6000,
				})
				return
			}

			let pleskData
			try {
				const { data } = await restApi.post('/juniper/client/subscription', {
					name: juniperClient.name,
					url: juniperClient.url,
					staging_url: juniperClient.staging_url,
					mc_client_id: juniperClient.mc_client_id,
				})
				pleskData = data
			} catch (error) {
				this.loadingJuniperCreate = false
				this.$swal.fire({
					icon: 'error',
					title: this.extractJuniperError(error, 'Failed to provision Plesk/Cloudflare'),
					timer: 6000,
				})
				return
			}

			try {
				await juniperApi.post('/clients/' + juniperClient.id + '/credentials', {
					ftp_user: pleskData.ftp_user,
					ftp_password: pleskData.ftp_password,
				})
			} catch (error) {
				this.loadingJuniperCreate = false
				this.$swal.fire({
					icon: 'error',
					title: this.extractJuniperError(error, 'Plesk provisioned, but failed to save FTP credentials'),
					timer: 6000,
				})
				return
			}

			this.client.juniper_id = juniperClient.id
			this.updateClient()
			this.loadingJuniperCreate = false
			this.$swal.fire({
				icon: 'success',
				title: 'Juniper instance successfully created',
				timer: 4000,
			})
			this.$createJuniperModal.hide()
		},

		extractJuniperError(error, fallback) {
			const data = error && error.response && error.response.data
			if (!data) return fallback
			if (typeof data.error === 'string') return data.error
			if (data.error && typeof data.error === 'object')
				return Object.values(data.error)
					.flat()
					.join(' ')
			if (data.message) return data.message
			return fallback
		},

		showOnboardingModal() {
			this.$newOnboardingModal.show()
			this.newOnboarding.name = this.client.name
			this.newOnboarding.client_id = this.client.id
			if (this.client.municipality_id) {
				this.newOnboarding.municipality_id = this.client.municipality_id
			}
			console.log(this.newOnboarding)
		},

		getOnboartingTypes() {
			restApi
				.get('/onboarding-type')
				.then(({ data }) => {
					this.onboardingTypes = data
					console.log(this.onboardingTypes)
				})
				.catch(error => {
					console.log(error)
				})
		},

		addOnboarding() {
			restApi
				.post('/onboarding', this.newOnboarding)
				.then(({ data }) => {
					this.$newOnboardingModal.hide()
					this.client.onboarding_id = data.id
					this.updateClient()
				})
				.catch(error => {
					console.log(error)
				})
		},

		// Secure File Upload Methods
		showSecureFileUploadModal() {
			this.loadUploadLinks()
			this.loadUploadedFiles()
			this.$secureFileUploadModal.show()
		},

		loadUploadLinks() {
			this.loadingLinks = true
			restApi
				.get(`/secure-upload/client/${this.client.id}`)
				.then(({ data }) => {
					this.uploadLinks = data.links
					this.loadingLinks = false
				})
				.catch(error => {
					console.error('Error loading upload links:', error)
					this.loadingLinks = false
					this.$swal.fire({
						icon: 'error',
						title: 'Error',
						text: 'Failed to load upload links',
					})
				})
		},

		createSecureLink() {
			this.creatingLink = true
			const payload = {
				client_id: this.client.id,
				validity_days: this.newUploadLink.validity_days,
				max_files: this.newUploadLink.max_files,
				max_file_size_mb: this.newUploadLink.max_file_size_mb,
				notes: this.newUploadLink.notes,
			}

			restApi
				.post('/secure-upload/create', payload)
				.then(({ data }) => {
					this.creatingLink = false
					this.$swal.fire({
						icon: 'success',
						title: 'Success',
						text: data.message,
						timer: 2000,
						showConfirmButton: false,
					})
					// Reset form
					this.newUploadLink = {
						validity_days: 10,
						max_files: 10,
						max_file_size_mb: 25,
						notes: '',
					}
					// Reload links
					this.loadUploadLinks()
				})
				.catch(error => {
					this.creatingLink = false
					console.error('Error creating link:', error)
					this.$swal.fire({
						icon: 'error',
						title: 'Error',
						text: error.response?.data?.message || 'Failed to create upload link',
					})
				})
		},

		revokeLink(linkId) {
			this.$swal
				.fire({
					title: 'Revoke Link?',
					text: 'This will prevent any further uploads using this link.',
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#d33',
					cancelButtonColor: '#3085d6',
					confirmButtonText: 'Yes, revoke it!',
				})
				.then(result => {
					if (result.isConfirmed) {
						restApi
							.post(`/secure-upload/${linkId}/revoke`)
							.then(({ data }) => {
								this.$swal.fire({
									icon: 'success',
									title: 'Revoked',
									text: data.message,
									timer: 2000,
									showConfirmButton: false,
								})
								this.loadUploadLinks()
							})
							.catch(error => {
								console.error('Error revoking link:', error)
								this.$swal.fire({
									icon: 'error',
									title: 'Error',
									text: 'Failed to revoke link',
								})
							})
					}
				})
		},

		deleteLink(linkId) {
			this.$swal
				.fire({
					title: 'Delete Link?',
					text: 'This action cannot be undone.',
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#d33',
					cancelButtonColor: '#3085d6',
					confirmButtonText: 'Yes, delete it!',
				})
				.then(result => {
					if (result.isConfirmed) {
						restApi
							.delete(`/secure-upload/${linkId}`)
							.then(({ data }) => {
								this.$swal.fire({
									icon: 'success',
									title: 'Deleted',
									text: data.message,
								})
								this.loadUploadLinks()
							})
							.catch(error => {
								console.error('Error deleting link:', error)
								this.$swal.fire({
									icon: 'error',
									title: 'Error',
									text: 'Failed to delete link',
								})
							})
					}
				})
		},

		loadUploadedFiles() {
			this.loadingFiles = true
			restApi
				.get(`/secure-upload/client/${this.client.id}/files`)
				.then(({ data }) => {
					this.uploadedFiles = data.files
					this.loadingFiles = false
				})
				.catch(error => {
					console.error('Error loading uploaded files:', error)
					this.loadingFiles = false
					this.$swal.fire({
						icon: 'error',
						title: 'Error',
						text: 'Failed to load uploaded files',
					})
				})
		},

		async downloadFile(fileId) {
			try {
				// Show loading indicator
				this.$swal.fire({
					title: 'Downloading...',
					html: 'Fetching encrypted file from secure storage...',
					allowOutsideClick: false,
					didOpen: () => {
						this.$swal.showLoading()
					},
				})

				// Get file metadata and encryption key
				const { data } = await restApi.get(`/secure-upload/file/${fileId}`)
				const fileInfo = data.file

				// Update loading message
				this.$swal.update({
					html: 'Decrypting file...',
				})

				// Fetch encrypted file from R2
				const r2Url = `https://securefileupload.townweb.com/download/${fileInfo.r2_key}`
				const response = await fetch(r2Url)
				if (!response.ok) {
					throw new Error('Failed to fetch file from storage')
				}

				const encryptedBlob = await response.blob()
				const encryptedArrayBuffer = await encryptedBlob.arrayBuffer()
				const encryptedData = new Uint8Array(encryptedArrayBuffer)

				// Decrypt file using XOR encryption
				const key = new TextEncoder().encode(fileInfo.encryption_key)
				const decrypted = new Uint8Array(encryptedData.length)

				for (let i = 0; i < encryptedData.length; i++) {
					decrypted[i] = encryptedData[i] ^ key[i % key.length]
				}

				// Create blob and trigger download
				const decryptedBlob = new Blob([decrypted], { type: fileInfo.mime_type })
				const url = window.URL.createObjectURL(decryptedBlob)
				const a = document.createElement('a')
				a.href = url
				a.download = fileInfo.original_name
				document.body.appendChild(a)
				a.click()
				document.body.removeChild(a)
				window.URL.revokeObjectURL(url)

				// Show success
				this.$swal.fire({
					icon: 'success',
					title: 'Download Complete',
					text: `${fileInfo.original_name} has been downloaded successfully`,
					timer: 2000,
					showConfirmButton: false,
				})
			} catch (error) {
				console.error('Error downloading file:', error)
				this.$swal.fire({
					icon: 'error',
					title: 'Download Failed',
					text: error.message || 'Failed to download and decrypt file',
				})
			}
		},

		copyToClipboard(text) {
			navigator.clipboard
				.writeText(text)
				.then(() => {
					this.$swal.fire({
						icon: 'success',
						title: 'Copied!',
						text: 'URL copied to clipboard',
						timer: 1500,
						showConfirmButton: false,
					})
				})
				.catch(err => {
					console.error('Failed to copy:', err)
					this.$swal.fire({
						icon: 'error',
						title: 'Error',
						text: 'Failed to copy to clipboard',
					})
				})
		},

		formatDate(dateString) {
			if (!dateString) return '-'
			const date = new Date(dateString)
			return date.toLocaleString('en-US', {
				month: 'short',
				day: 'numeric',
				year: 'numeric',
				hour: '2-digit',
				minute: '2-digit',
			})
		},

		// Sync client with Intercom
		syncWithIntercom() {
			this.syncingIntercom = true
			restApi
				.post(`/intercom/sync-client/${this.client.id}`)
				.then(({ data }) => {
					this.syncingIntercom = false
					this.$swal.fire({
						icon: 'success',
						title: 'Synced with Intercom',
						text: `Company and ${data.contacts_synced || 0} contact(s) synced successfully.`,
						timer: 4000,
					})
				})
				.catch(error => {
					this.syncingIntercom = false
					this.$swal.fire({
						icon: 'error',
						title: 'Intercom Sync Failed',
						text: handleErrors(error, 'Failed to sync with Intercom'),
						timer: 6000,
					})
				})
		},
	},

	watch: {
		twWeatherActive: function() {
			if (this.twWeatherActive) {
				this.client.tw_weather = 'yes'
			} else {
				this.client.tw_weather = 'no'
			}
		},
		$route(to, from) {
			if (to !== from) {
				location.reload()
			}
		},
		townweb: function() {
			if (this.townweb) {
				this.client.tw_client = 'yes'
				this.hosting = false
			} else {
				this.client.tw_client = 'no'
			}
		},
		heygov: function() {
			if (this.heygov) {
				this.client.hg_client = 'yes'
				this.hosting = false
			} else {
				this.client.hg_client = 'no'
			}
		},
		tweak: function() {
			if (this.tweak) {
				this.client.tk_client = 'yes'
				this.townweb = false
				this.heygov = false
				this.hosting = false
			} else {
				this.client.tk_client = 'no'
			}
		},
		hosting: function() {
			if (this.hosting) {
				this.client.hosting = 'yes'
				this.townweb = false
				this.heygov = false
				this.tweak = false
			} else {
				this.client.hosting = 'no'
			}
		},
		'juniperClient.url'(newValue) {
			const clientUrl = newValue
				.replace('https://', '')
				.replace('http://', '')
				.replace('www.', '')
				.replace('/', '')
			if (clientUrl !== newValue) {
				this.juniperClient.url = clientUrl
			}
		},
	},
	filters: {
		localDate: function(value) {
			if (!value) return ''
			value = new Date(value)
			return value.toLocaleDateString()
		},
		usDate: function(value) {
			if (!value) return ''
			const date = new Date(value)
			const month = String(date.getMonth() + 1).padStart(2, '0') // Months are 0-based
			const day = String(date.getDate()).padStart(2, '0')
			const year = date.getFullYear()
			return `${month}/${day}/${year}`
		},
		localDateTime: function(value) {
			if (!value) return ''
			value = new Date(value)
			return value.toLocaleString()
		},
		usDateTime: function(value) {
			if (!value) return ''
			const date = new Date(value)
			const month = String(date.getMonth() + 1).padStart(2, '0') // Months are 0-based
			const day = String(date.getDate()).padStart(2, '0')
			const year = date.getFullYear()
			const hours = String(date.getHours()).padStart(2, '0')
			const minutes = String(date.getMinutes()).padStart(2, '0')
			const seconds = String(date.getSeconds()).padStart(2, '0')
			return `${month}/${day}/${year} ${hours}:${minutes}:${seconds}`
		},
	},
}
</script>

<style lang="scss" scoped>
.rating-item {
	&:hover {
		background-color: whitesmoke;
		border-radius: 5px;
	}
}
.contact-item {
	&:hover {
		background-color: whitesmoke;
		border-radius: 5px;
	}
}

.timeline {
	margin: 0 0 45px;
	padding: 0;
	position: relative;
}
.timeline::before {
	border-radius: 0.25rem;
	background: #dee2e6;
	bottom: 0;
	content: '';
	left: 31px;
	margin: 0;
	position: absolute;
	top: 0;
	width: 4px;
}
.timeline > div {
	margin-bottom: 15px;
	margin-right: 10px;
	position: relative;
}
.timeline > div::after,
.timeline > div::before {
	content: '';
	display: table;
}
.timeline > .time-label > span {
	font-weight: 500;
	color: #6c757d;
}
.timeline > .time-label > span {
	border-radius: 4px;
	background-color: #fff;
	display: inline-block;
	font-weight: 600;
	padding: 5px;
}
.timeline-inverse > div > .timeline-item {
	box-shadow: none;
	background: #f8f9fa;
	border: 1px solid #dee2e6;
}

.timeline > div > .timeline-item {
	box-shadow: 0 0 1px rgb(0 0 0 / 13%), 0 1px 3px rgb(0 0 0 / 20%);
	border-radius: 0.25rem;
	background: #fff;
	color: #495057;
	margin-left: 60px;
	margin-right: 15px;
	margin-top: 0;
	padding: 0;
	position: relative;
}
.bg-danger-light {
	background-color: #ffe6e6 !important;
}

.note-item {
	.note-item-edit {
		display: none;
	}
	.note-item-delete {
		display: none;
	}
	.note-item-date {
		display: none;
		position: absolute;
		margin-top: -51px;
		margin-left: 5px;
		font-size: 10px;
	}
	&:hover {
		.note-item-delete {
			display: block;
		}
		.note-item-edit {
			display: block;
		}
		.note-item-date {
			display: block;
		}
	}
}
.btn-connect {
	background-color: white;
	margin: 0px 5px;
	height: 120px;
	display: flex;
	justify-content: center;
	align-items: center;
	line-height: 14px;
	width: 150px;
}

.search-results-container {
	.search-results {
		width: 100%;
		.search-item {
			cursor: pointer;
			&:hover {
				background-color: whitesmoke;
				border-radius: 0.5rem;
			}
		}
	}
}

.connect-status {
	position: absolute;
	top: -5px;
	right: -5px;
}

.connect-title {
	position: absolute;
	top: 10px;
}

.input-group-text {
	border: none;
}

.form-group-sk {
	padding: 5px 10px;
	background-color: #efefef;
	border-radius: 10px;
}

.form-label-sk {
	font-size: 12px;
	margin-bottom: 0px;
	font-weight: 600;
}
</style>
